import "./src1970441075.3d6b5283.js";
import "./src1970441075.89463b61.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3e1a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3e1a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4DjaP = parcelRequire("4DjaP");

var $4zVoD = parcelRequire("4zVoD");
var $7Y1KN = parcelRequire("7Y1KN");
var $w8bd7 = parcelRequire("w8bd7");
var $arYTK = parcelRequire("arYTK");
var $dHEV3 = parcelRequire("dHEV3");
var $7oIfw = parcelRequire("7oIfw");
var $dPLPm = parcelRequire("dPLPm");
var $bZENS = parcelRequire("bZENS");
var $B8qZj = parcelRequire("B8qZj");
var $f82Ej = parcelRequire("f82Ej");
var $jeERW = parcelRequire("jeERW");
var $hv7EP = parcelRequire("hv7EP");

var $7C8eI = parcelRequire("7C8eI");

var $eUf1i = parcelRequire("eUf1i");

var $w8bd7 = parcelRequire("w8bd7");

var $iaBjX = parcelRequire("iaBjX");

var $cDZNc = parcelRequire("cDZNc");
let $ae410015a73adcb9$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $ae410015a73adcb9$export$b0914730ee1f6c80() {
    if ($ae410015a73adcb9$var$errorsInstrumented) return;
    /**
   * If an error or unhandled promise occurs, we mark the active root span as failed
   */ function errorCallback() {
        const activeSpan = (0, $iaBjX.getActiveSpan)();
        const rootSpan = activeSpan && (0, $iaBjX.getRootSpan)(activeSpan);
        if (rootSpan) {
            const message = 'internal_error';
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: (0, $cDZNc.SPAN_STATUS_ERROR),
                message: message
            });
        }
    }
    // The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
    // node.js default exit behaviour
    errorCallback.tag = 'sentry_tracingErrorCallback';
    $ae410015a73adcb9$var$errorsInstrumented = true;
    (0, $7C8eI.addGlobalErrorInstrumentationHandler)(errorCallback);
    (0, $eUf1i.addGlobalUnhandledRejectionInstrumentationHandler)(errorCallback);
}


var $gKbJW = parcelRequire("gKbJW");
var $iaBjX = parcelRequire("iaBjX");
var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $gKbJW = parcelRequire("gKbJW");

var $w8bd7 = parcelRequire("w8bd7");

var $B8qZj = parcelRequire("B8qZj");

var $9VTV3 = parcelRequire("9VTV3");

var $4L3PL = parcelRequire("4L3PL");

var $iaBjX = parcelRequire("iaBjX");

var $7Y1KN = parcelRequire("7Y1KN");

var $7oIfw = parcelRequire("7oIfw");

var $arYTK = parcelRequire("arYTK");

var $iaBjX = parcelRequire("iaBjX");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $427ccfee27d19206$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $arYTK.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $arYTK.generateSpanId)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $iaBjX.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}



var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $3pr37 = parcelRequire("3pr37");

var $gKbJW = parcelRequire("gKbJW");

var $w8bd7 = parcelRequire("w8bd7");

var $arYTK = parcelRequire("arYTK");

var $iaBjX = parcelRequire("iaBjX");

var $7Y1KN = parcelRequire("7Y1KN");

var $7oIfw = parcelRequire("7oIfw");

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $iaBjX = parcelRequire("iaBjX");
/**
 * Print a log message for a started span.
 */ function $e20ae7490e3c1b73$export$2f3d84e767c9592b(span) {
    if (!(0, $hv7EP.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $iaBjX.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $iaBjX.spanIsSampled)(span);
    const rootSpan = (0, $iaBjX.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $iaBjX.spanToJSON)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $w8bd7.debug).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $e20ae7490e3c1b73$export$b77c830667a4d630(span) {
    if (!(0, $hv7EP.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $iaBjX.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $iaBjX.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $w8bd7.debug).log(msg);
}



var $hv7EP = parcelRequire("hv7EP");

var $gKbJW = parcelRequire("gKbJW");

var $w8bd7 = parcelRequire("w8bd7");

var $iaBjX = parcelRequire("iaBjX");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $2174c183125e1337$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $iaBjX.getActiveSpan)()) {
    const rootSpan = activeSpan && (0, $iaBjX.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: value,
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $2174c183125e1337$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



var $98MSm = parcelRequire("98MSm");
const $0d91138d8cb41446$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $0d91138d8cb41446$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $arYTK.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $arYTK.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, $7Y1KN.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'manual',
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $iaBjX.TRACE_FLAG_SAMPLED) : (0, $iaBjX.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $iaBjX.spanTimeInputToSeconds)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $iaBjX.spanTimeInputToSeconds)(endTimestamp);
        (0, $e20ae7490e3c1b73$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $iaBjX.getStatusMessage)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: (0, $2174c183125e1337$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $iaBjX.getRootSpan)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $iaBjX.getRootSpan)(this).spanContext().spanId : undefined,
            links: (0, $iaBjX.convertSpanLinksForEnvelope)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('[Tracing] Adding an event to span:', name);
        const time = $0d91138d8cb41446$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $7Y1KN.timestampInSeconds)();
        const attributes = $0d91138d8cb41446$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $iaBjX.spanTimeInputToSeconds)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $dHEV3.getClient)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $iaBjX.getRootSpan)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $0d91138d8cb41446$var$sendSpanEnvelope((0, $3pr37.createSpanEnvelope)([
                this
            ], client));
            else {
                (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $98MSm.getCapturedScopesOnSpan)(this).scope || (0, $dHEV3.getCurrentScope)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$0d91138d8cb41446$var$isFullFinishedSpan((0, $iaBjX.spanToJSON)(this))) return undefined;
        if (!this._name) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $98MSm.getCapturedScopesOnSpan)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $iaBjX.getSpanDescendants)(this).filter((span)=>span !== this && !$0d91138d8cb41446$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $iaBjX.spanToJSON)(span)).filter($0d91138d8cb41446$var$isFullFinishedSpan);
        const source = this._attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        spans.forEach((span)=>{
            delete span.data[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $iaBjX.spanToTransactionTraceContext)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $0d91138d8cb41446$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $0d91138d8cb41446$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $7oIfw.getDynamicSamplingContextFromSpan)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $2174c183125e1337$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $0d91138d8cb41446$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $0d91138d8cb41446$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $0d91138d8cb41446$var$isStandaloneSpan(span) {
    return span instanceof $0d91138d8cb41446$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $0d91138d8cb41446$var$sendSpanEnvelope(envelope) {
    const client = (0, $dHEV3.getClient)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}



var $cDZNc = parcelRequire("cDZNc");

var $dO8ql = parcelRequire("dO8ql");

var $2vdTp = parcelRequire("2vdTp");

var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $gKbJW = parcelRequire("gKbJW");

var $7Fxjp = parcelRequire("7Fxjp");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");
/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $261c8bf6b2834624$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $261c8bf6b2834624$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $261c8bf6b2834624$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $9ISAs.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        onSuccess(res);
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    onSuccess(value);
    return value;
}



var $B8qZj = parcelRequire("B8qZj");

var $a5tr3 = parcelRequire("a5tr3");

var $arYTK = parcelRequire("arYTK");

var $4L3PL = parcelRequire("4L3PL");

var $iaBjX = parcelRequire("iaBjX");

var $jeERW = parcelRequire("jeERW");

var $7oIfw = parcelRequire("7oIfw");


var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $B8qZj = parcelRequire("B8qZj");

var $a5tr3 = parcelRequire("a5tr3");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $a8771da3c090f948$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $B8qZj.hasSpansEnabled)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $a5tr3.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}





var $cDZNc = parcelRequire("cDZNc");

var $98MSm = parcelRequire("98MSm");
/* eslint-disable max-lines */ const $07238d64f16b4415$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $07238d64f16b4415$export$a1bd95187356f372(options, callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $07238d64f16b4415$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $dHEV3.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $07238d64f16b4415$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $dHEV3.getCurrentScope)();
            const parentSpan = $07238d64f16b4415$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $427ccfee27d19206$export$d6636b700b76c516)() : $07238d64f16b4415$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $4L3PL._setSpanForScope)(scope, activeSpan);
            return (0, $261c8bf6b2834624$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $iaBjX.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $cDZNc.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $07238d64f16b4415$export$c10292ad04b92aea(options, callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $07238d64f16b4415$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $dHEV3.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $07238d64f16b4415$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $dHEV3.getCurrentScope)();
            const parentSpan = $07238d64f16b4415$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $427ccfee27d19206$export$d6636b700b76c516)() : $07238d64f16b4415$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $4L3PL._setSpanForScope)(scope, activeSpan);
            return (0, $261c8bf6b2834624$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $iaBjX.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $cDZNc.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $07238d64f16b4415$export$63dbba021a6b4047(options) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $07238d64f16b4415$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $dHEV3.withScope)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$07238d64f16b4415$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $dHEV3.getCurrentScope)();
        const parentSpan = $07238d64f16b4415$var$getParentSpan(scope, customParentSpan);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $427ccfee27d19206$export$d6636b700b76c516)();
        return $07238d64f16b4415$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $07238d64f16b4415$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $dO8ql.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $dHEV3.getClient)();
    const incomingDsc = (0, $7Fxjp.baggageHeaderToDynamicSamplingContext)(baggage);
    if (client && !(0, $jeERW.shouldContinueTrace)(client, incomingDsc?.org_id)) return $07238d64f16b4415$export$f90b03291402f553(callback);
    return (0, $dHEV3.withScope)((scope)=>{
        const propagationContext = (0, $jeERW.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $07238d64f16b4415$export$e57ac09b143d92a2(span, callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $dHEV3.withScope)((scope)=>{
        (0, $4L3PL._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $07238d64f16b4415$export$869298f9835abc68(callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $dHEV3.withScope)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$07238d64f16b4415$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$07238d64f16b4415$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $07238d64f16b4415$export$f90b03291402f553(callback) {
    return (0, $dHEV3.withScope)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $arYTK.generateTraceId)(),
            sampleRand: Math.random()
        });
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $07238d64f16b4415$export$e57ac09b143d92a2(null, callback);
    });
}
function $07238d64f16b4415$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $B8qZj.hasSpansEnabled)()) {
        const span = new (0, $427ccfee27d19206$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $7oIfw.getDynamicSamplingContextFromSpan)(span)
            };
            (0, $7oIfw.freezeDscOnSpan)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $dHEV3.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $07238d64f16b4415$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $iaBjX.addChildSpanToSpan)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $7oIfw.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $iaBjX.spanIsSampled)(parentSpan);
        span = $07238d64f16b4415$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $7oIfw.freezeDscOnSpan)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $07238d64f16b4415$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $7oIfw.freezeDscOnSpan)(span, dsc);
    }
    (0, $e20ae7490e3c1b73$export$2f3d84e767c9592b)(span);
    (0, $98MSm.setCapturedScopesOnSpan)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $07238d64f16b4415$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $iaBjX.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $07238d64f16b4415$var$getAcs() {
    const carrier = (0, $2vdTp.getMainCarrier)();
    return (0, $dO8ql.getAsyncContextStrategy)(carrier);
}
function $07238d64f16b4415$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $dHEV3.getClient)();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$07238d64f16b4415$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $a8771da3c090f948$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $a5tr3.parseSampleRate)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $0d91138d8cb41446$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $07238d64f16b4415$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$07238d64f16b4415$var$SUPPRESS_TRACING_KEY] ? false : (0, $iaBjX.spanIsSampled)(parentSpan);
    const childSpan = sampled ? new (0, $0d91138d8cb41446$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $427ccfee27d19206$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $iaBjX.addChildSpanToSpan)(parentSpan, childSpan);
    const client = (0, $dHEV3.getClient)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $07238d64f16b4415$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, $4L3PL._getSpanForScope)(scope);
    if (!span) return undefined;
    const client = (0, $dHEV3.getClient)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $iaBjX.getRootSpan)(span);
    return span;
}
function $07238d64f16b4415$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $07238d64f16b4415$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}


const $457bc1d0cff66550$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $457bc1d0cff66550$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $457bc1d0cff66550$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $457bc1d0cff66550$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $457bc1d0cff66550$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $457bc1d0cff66550$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $457bc1d0cff66550$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $457bc1d0cff66550$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $457bc1d0cff66550$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $457bc1d0cff66550$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = (0, $dHEV3.getClient)();
    if (!client || !(0, $B8qZj.hasSpansEnabled)()) {
        const span = new (0, $427ccfee27d19206$export$d6636b700b76c516)();
        const dsc = {
            sample_rate: '0',
            sampled: 'false',
            ...(0, $7oIfw.getDynamicSamplingContextFromSpan)(span)
        };
        (0, $7oIfw.freezeDscOnSpan)(span, dsc);
        return span;
    }
    const scope = (0, $dHEV3.getCurrentScope)();
    const previousActiveSpan = (0, $iaBjX.getActiveSpan)();
    const span = $457bc1d0cff66550$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof (0, $427ccfee27d19206$export$d6636b700b76c516)) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $7Y1KN.timestampInSeconds)();
            const spanEndTimestamp = (0, $iaBjX.spanTimeInputToSeconds)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $iaBjX.getSpanDescendants)(span).filter((child)=>child !== span);
            const spanJson = (0, $iaBjX.spanToJSON)(span);
            // If we have no spans, we just end, nothing else to do here
            // Likewise, if users explicitly ended the span, we simply end the span without timestamp adjustment
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = (0, $iaBjX.spanToJSON)(current);
                if (!currentSpanJson.timestamp) return acc;
                // Ignored spans will get dropped later (in the client) but since we already adjust
                // the idle span end timestamp here, we can already take to-be-ignored spans out of
                // the calculation here.
                if (ignoreSpans && (0, $9VTV3.shouldIgnoreSpan)(currentSpanJson, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, undefined);
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = spanJson.start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $457bc1d0cff66550$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $457bc1d0cff66550$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $7Y1KN.timestampInSeconds)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $7Y1KN.timestampInSeconds)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $4L3PL._setSpanForScope)(scope, previousActiveSpan);
        const spanJSON = (0, $iaBjX.spanToJSON)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute((0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), _finishReason);
        (0, $w8bd7.debug).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $iaBjX.getSpanDescendants)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $cDZNc.SPAN_STATUS_ERROR),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $iaBjX.spanToJSON)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $hv7EP.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $w8bd7.debug).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $w8bd7.debug).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $iaBjX.removeChildSpanFromSpan)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $iaBjX.spanToJSON)(startedSpan).timestamp || startedSpan instanceof (0, $0d91138d8cb41446$export$a92149b045260d9f) && startedSpan.isStandaloneSpan()) return;
        const allSpans = (0, $iaBjX.getSpanDescendants)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $cDZNc.SPAN_STATUS_ERROR),
                message: 'deadline_exceeded'
            });
            _finishReason = $457bc1d0cff66550$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $457bc1d0cff66550$var$_startIdleSpan(options) {
    const span = (0, $07238d64f16b4415$export$63dbba021a6b4047)(options);
    (0, $4L3PL._setSpanForScope)((0, $dHEV3.getCurrentScope)(), span);
    (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('[Tracing] Started span is an idle span');
    return span;
}



var $3kfyQ = parcelRequire("3kfyQ");
var $7Y1KN = parcelRequire("7Y1KN");
var $iaBjX = parcelRequire("iaBjX");
var $dPLPm = parcelRequire("dPLPm");
var $9ISAs = parcelRequire("9ISAs");
var $f82Ej = parcelRequire("f82Ej");
var $gKbJW = parcelRequire("gKbJW");
var $kWdMm = parcelRequire("kWdMm");

var $bxVth = parcelRequire("bxVth");

var $7Y1KN = parcelRequire("7Y1KN");
var $w8bd7 = parcelRequire("w8bd7");
var $dHEV3 = parcelRequire("dHEV3");
var $dPLPm = parcelRequire("dPLPm");
var $gKbJW = parcelRequire("gKbJW");

var $5q5cQ = parcelRequire("5q5cQ");

var $w8bd7 = parcelRequire("w8bd7");
var $iFp2j = parcelRequire("iFp2j");

var $5q5cQ = parcelRequire("5q5cQ");

var $bxVth = parcelRequire("bxVth");
const $860c3a12e4404d2c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $860c3a12e4404d2c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $860c3a12e4404d2c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



var $bxVth = parcelRequire("bxVth");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $d91fc0b969a93c29$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



var $bxVth = parcelRequire("bxVth");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $8ead2cb8061fa04e$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $bxVth.WINDOW).performance?.getEntriesByType?.('navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases a zero value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // - https://github.com/GoogleChrome/web-vitals/issues/137
    // - https://github.com/GoogleChrome/web-vitals/issues/162
    // - https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b55faa426ae84be6$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $8ead2cb8061fa04e$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d29323e937e5722$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $8ead2cb8061fa04e$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $bxVth.WINDOW).document?.prerendering || (0, $b55faa426ae84be6$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else if ((0, $bxVth.WINDOW).document?.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $d91fc0b969a93c29$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3133a54d7b75dc73$var$instanceMap = new WeakMap();
/**
 * A function that accepts and identity object and a class object and returns
 * either a new instance of that class or an existing instance, if the
 * identity object was previously used.
 */ function $3133a54d7b75dc73$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    if (!$3133a54d7b75dc73$var$instanceMap.get(identityObj)) $3133a54d7b75dc73$var$instanceMap.set(identityObj, new ClassObj());
    return $3133a54d7b75dc73$var$instanceMap.get(identityObj);
}


/* eslint-disable jsdoc/require-jsdoc */ /*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $ca199f5320af87a1$export$4050f7f955e19aa0 {
    constructor(){
        $ca199f5320af87a1$export$4050f7f955e19aa0.prototype.__init.call(this);
        $ca199f5320af87a1$export$4050f7f955e19aa0.prototype.__init2.call(this);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init() {
        this._sessionValue = 0;
    }
    // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init2() {
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        // Only count layout shifts without recent user input.
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        // This previously used `this._sessionEntries.at(-1)` but that is ES2022. We support ES2021 and earlier.
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        // If the entry occurred less than 1 second after the previous entry
        // and less than 5 seconds after the first entry in the session,
        // include the entry in the current session. Otherwise, start a new
        // session.
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $4370472335afb2a9$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {
    // Do nothing.
    }
    return;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e702979216793a64$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};





var $bxVth = parcelRequire("bxVth");

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $09e3e1b2860f2203$var$firstHiddenTime = -1;
const $09e3e1b2860f2203$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $bxVth.WINDOW).document?.visibilityState === 'hidden' && !(0, $bxVth.WINDOW).document?.prerendering ? 0 : Infinity;
};
const $09e3e1b2860f2203$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $bxVth.WINDOW).document.visibilityState === 'hidden' && $09e3e1b2860f2203$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $09e3e1b2860f2203$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $09e3e1b2860f2203$var$removeChangeListeners();
    }
};
const $09e3e1b2860f2203$var$addChangeListeners = ()=>{
    addEventListener('visibilitychange', $09e3e1b2860f2203$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener('prerenderingchange', $09e3e1b2860f2203$var$onVisibilityUpdate, true);
};
const $09e3e1b2860f2203$var$removeChangeListeners = ()=>{
    removeEventListener('visibilitychange', $09e3e1b2860f2203$var$onVisibilityUpdate, true);
    removeEventListener('prerenderingchange', $09e3e1b2860f2203$var$onVisibilityUpdate, true);
};
const $09e3e1b2860f2203$export$443f86b2c77012c4 = ()=>{
    if ((0, $bxVth.WINDOW).document && $09e3e1b2860f2203$var$firstHiddenTime < 0) {
        // Check if we have a previous hidden `visibility-state` performance entry.
        const activationStart = (0, $b55faa426ae84be6$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $bxVth.WINDOW).document.prerendering ? globalThis.performance.getEntriesByType('visibility-state').filter((e)=>e.name === 'hidden' && e.startTime > activationStart)[0]?.startTime : undefined;
        // Prefer that, but if it's not available and the document is hidden when
        // this code runs, assume it was hidden since navigation start. This isn't
        // a perfect heuristic, but it's the best we can do until the
        // `visibility-state` performance entry becomes available in all browsers.
        $09e3e1b2860f2203$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $09e3e1b2860f2203$var$initHiddenTime();
        // We're still going to listen to for changes so we can handle things like
        // bfcache restores and/or prerender without having to examine individual
        // timestamps in detail.
        $09e3e1b2860f2203$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $09e3e1b2860f2203$var$firstHiddenTime;
        }
    };
};





var $bxVth = parcelRequire("bxVth");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cec61b4cc5942f0$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $bxVth.WINDOW).document?.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $9e84a16adc0e9ff1$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $9e84a16adc0e9ff1$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $9cec61b4cc5942f0$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $09e3e1b2860f2203$export$443f86b2c77012c4)();
        const metric = (0, $1d29323e937e5722$export$3c29b44508a0612b)('FCP');
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === 'first-contentful-paint') {
                po.disconnect();
                // Only report if the page wasn't hidden prior to the first paint.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The activationStart reference is used because FCP should be
                    // relative to page activation rather than navigation start if the
                    // page was prerendered. But in cases where `activationStart` occurs
                    // after the FCP, this time should be clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $b55faa426ae84be6$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $4370472335afb2a9$export$d1203567a167490e)('paint', handleEntries);
        if (po) report = (0, $860c3a12e4404d2c$export$17679dccdd551979)(onReport, metric, $9e84a16adc0e9ff1$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $3a94cc11907d66f2$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $3a94cc11907d66f2$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $9e84a16adc0e9ff1$export$fe3c86b74e15d5de)((0, $e702979216793a64$export$b841d51e31c12bab)(()=>{
        const metric = (0, $1d29323e937e5722$export$3c29b44508a0612b)('CLS', 0);
        let report;
        const layoutShiftManager = (0, $3133a54d7b75dc73$export$7c74c9b2462ddb3c)(opts, (0, $ca199f5320af87a1$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $4370472335afb2a9$export$d1203567a167490e)('layout-shift', handleEntries);
        if (po) {
            report = (0, $860c3a12e4404d2c$export$17679dccdd551979)(onReport, metric, $3a94cc11907d66f2$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $bxVth.WINDOW).document?.addEventListener('visibilitychange', ()=>{
                if ((0, $bxVth.WINDOW).document?.visibilityState === 'hidden') {
                    handleEntries(po.takeRecords());
                    report(true);
                }
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            (0, $bxVth.WINDOW)?.setTimeout?.(report);
        }
    }));
};






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $c5a5a09cbfa9c4b8$var$interactionCountEstimate = 0;
let $c5a5a09cbfa9c4b8$var$minKnownInteractionId = Infinity;
let $c5a5a09cbfa9c4b8$var$maxKnownInteractionId = 0;
const $c5a5a09cbfa9c4b8$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $c5a5a09cbfa9c4b8$var$minKnownInteractionId = Math.min($c5a5a09cbfa9c4b8$var$minKnownInteractionId, e.interactionId);
            $c5a5a09cbfa9c4b8$var$maxKnownInteractionId = Math.max($c5a5a09cbfa9c4b8$var$maxKnownInteractionId, e.interactionId);
            $c5a5a09cbfa9c4b8$var$interactionCountEstimate = $c5a5a09cbfa9c4b8$var$maxKnownInteractionId ? ($c5a5a09cbfa9c4b8$var$maxKnownInteractionId - $c5a5a09cbfa9c4b8$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $c5a5a09cbfa9c4b8$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $c5a5a09cbfa9c4b8$export$8a962f2683a476d1 = ()=>{
    return $c5a5a09cbfa9c4b8$var$po ? $c5a5a09cbfa9c4b8$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $c5a5a09cbfa9c4b8$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $c5a5a09cbfa9c4b8$var$po) return;
    $c5a5a09cbfa9c4b8$var$po = (0, $4370472335afb2a9$export$d1203567a167490e)('event', $c5a5a09cbfa9c4b8$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $8ffd09e59709fac8$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $8ffd09e59709fac8$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $8ffd09e59709fac8$var$getInteractionCountForNavigation = ()=>{
    return (0, $c5a5a09cbfa9c4b8$export$8a962f2683a476d1)() - $8ffd09e59709fac8$var$prevInteractionCount;
};
/**
 *
 */ class $8ffd09e59709fac8$export$aaa80641d584351c {
    constructor(){
        $8ffd09e59709fac8$export$aaa80641d584351c.prototype.__init.call(this);
        $8ffd09e59709fac8$export$aaa80641d584351c.prototype.__init2.call(this);
    }
    /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */ // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init() {
        this._longestInteractionList = [];
    }
    /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */ // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init2() {
        this._longestInteractionMap = new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $8ffd09e59709fac8$var$prevInteractionCount = (0, $c5a5a09cbfa9c4b8$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($8ffd09e59709fac8$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (interaction || this._longestInteractionList.length < $8ffd09e59709fac8$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (interaction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $8ffd09e59709fac8$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($8ffd09e59709fac8$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction of removedInteractions)this._longestInteractionMap.delete(interaction.id);
            }
            // Call any post-processing on the interaction
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}




var $bxVth = parcelRequire("bxVth");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 or 5.x but we continue
// to use the web-vitals 3.5.2 versiondue to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari <14.4) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v11): If we decide to drop support for Safari 14.4, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $331119233677988a$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $bxVth.WINDOW).document?.visibilityState === 'hidden') cb(event);
    };
    if ((0, $bxVth.WINDOW).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};





var $bxVth = parcelRequire("bxVth");


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $9f370026cb8407c4$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $bxVth.WINDOW).requestIdleCallback || (0, $bxVth.WINDOW).setTimeout;
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $bxVth.WINDOW).document?.visibilityState === 'hidden') cb();
    else {
        // eslint-disable-next-line no-param-reassign
        cb = (0, $e702979216793a64$export$b841d51e31c12bab)(cb);
        rIC(cb);
        // sentry: we use onHidden instead of directly listening to visibilitychange
        // because some browsers we still support (Safari <14.4) don't fully support
        // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
        (0, $331119233677988a$export$91ec2be6fdd8f1b4)(cb);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $8a3e3089ba0d21a7$export$7f4cb060ded9173c = [
    200,
    500
];
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $8a3e3089ba0d21a7$var$DEFAULT_DURATION_THRESHOLD = 40;
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed
 * to control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 will not
 * be reported. To avoid reporting no interactions in these cases, the library
 * will fall back to the input delay of the first interaction. Note that this
 * will not affect your 75th percentile INP value unless that value is also
 * less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $8a3e3089ba0d21a7$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!(globalThis.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype)) return;
    (0, $9cec61b4cc5942f0$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $c5a5a09cbfa9c4b8$export$67d90cda6b78a2eb)();
        const metric = (0, $1d29323e937e5722$export$3c29b44508a0612b)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const interactionManager = (0, $3133a54d7b75dc73$export$7c74c9b2462ddb3c)(opts, (0, $8ffd09e59709fac8$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $9f370026cb8407c4$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $4370472335afb2a9$export$d1203567a167490e)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $8a3e3089ba0d21a7$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $860c3a12e4404d2c$export$17679dccdd551979)(onReport, metric, $8a3e3089ba0d21a7$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            // sentry: we use onHidden instead of directly listening to visibilitychange
            // because some browsers we still support (Safari <14.4) don't fully support
            // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
            (0, $331119233677988a$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};



var $bxVth = parcelRequire("bxVth");





/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // eslint-disable-next-line jsdoc/require-jsdoc
class $ba6edd20ee57119c$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $d19a62da7758f6a8$export$948521ca5b0e1b17 = [
    2500,
    4000
];
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $d19a62da7758f6a8$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $9cec61b4cc5942f0$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $09e3e1b2860f2203$export$443f86b2c77012c4)();
        const metric = (0, $1d29323e937e5722$export$3c29b44508a0612b)('LCP');
        let report;
        const lcpEntryManager = (0, $3133a54d7b75dc73$export$7c74c9b2462ddb3c)(opts, (0, $ba6edd20ee57119c$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $b55faa426ae84be6$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $4370472335afb2a9$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $860c3a12e4404d2c$export$17679dccdd551979)(onReport, metric, $d19a62da7758f6a8$export$948521ca5b0e1b17, opts.reportAllChanges);
            // Ensure this logic only runs once, since it can be triggered from
            // any of three different event listeners below.
            const stopListening = (0, $e702979216793a64$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            // Stop listening after input or visibilitychange.
            // Note: while scrolling is an input that stops LCP observation, it's
            // unreliable since it can be programmatically generated.
            // See: https://github.com/GoogleChrome/web-vitals/issues/75
            for (const type of [
                'keydown',
                'click',
                'visibilitychange'
            ])// Wrap the listener in an idle callback so it's run in a separate
            // task to reduce potential INP impact.
            // https://github.com/GoogleChrome/web-vitals/issues/383
            if ((0, $bxVth.WINDOW).document) addEventListener(type, ()=>(0, $9f370026cb8407c4$export$d3314d5863fc1fef)(stopListening), {
                capture: true,
                once: true
            });
        }
    });
};




var $bxVth = parcelRequire("bxVth");





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $984e75d1a7843938$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $984e75d1a7843938$var$whenReady = (callback)=>{
    if ((0, $bxVth.WINDOW).document?.prerendering) (0, $9cec61b4cc5942f0$export$8bdb38a5671b594e)(()=>$984e75d1a7843938$var$whenReady(callback));
    else if ((0, $bxVth.WINDOW).document?.readyState !== 'complete') addEventListener('load', ()=>$984e75d1a7843938$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $984e75d1a7843938$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $1d29323e937e5722$export$3c29b44508a0612b)('TTFB');
    const report = (0, $860c3a12e4404d2c$export$17679dccdd551979)(onReport, metric, $984e75d1a7843938$export$65c59ea8064668fc, opts.reportAllChanges);
    $984e75d1a7843938$var$whenReady(()=>{
        const navigationEntry = (0, $8ead2cb8061fa04e$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $b55faa426ae84be6$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $eac0fdc9019e6986$var$handlers = {};
const $eac0fdc9019e6986$var$instrumented = {};
let $eac0fdc9019e6986$var$_previousCls;
let $eac0fdc9019e6986$var$_previousLcp;
let $eac0fdc9019e6986$var$_previousTtfb;
let $eac0fdc9019e6986$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $eac0fdc9019e6986$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $eac0fdc9019e6986$var$addMetricObserver('cls', callback, $eac0fdc9019e6986$var$instrumentCls, $eac0fdc9019e6986$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $eac0fdc9019e6986$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $eac0fdc9019e6986$var$addMetricObserver('lcp', callback, $eac0fdc9019e6986$var$instrumentLcp, $eac0fdc9019e6986$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a TTFD metric is available.
 */ function $eac0fdc9019e6986$export$699d9529c099a797(callback) {
    return $eac0fdc9019e6986$var$addMetricObserver('ttfb', callback, $eac0fdc9019e6986$var$instrumentTtfb, $eac0fdc9019e6986$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $eac0fdc9019e6986$export$da3b76aa2022cbd7(callback) {
    return $eac0fdc9019e6986$var$addMetricObserver('inp', callback, $eac0fdc9019e6986$var$instrumentInp, $eac0fdc9019e6986$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $eac0fdc9019e6986$export$69816c1a049f8db6(type, callback) {
    $eac0fdc9019e6986$var$addHandler(type, callback);
    if (!$eac0fdc9019e6986$var$instrumented[type]) {
        $eac0fdc9019e6986$var$instrumentPerformanceObserver(type);
        $eac0fdc9019e6986$var$instrumented[type] = true;
    }
    return $eac0fdc9019e6986$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $eac0fdc9019e6986$var$triggerHandlers(type, data) {
    const typeHandlers = $eac0fdc9019e6986$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $5q5cQ.DEBUG_BUILD) && (0, $w8bd7.debug).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $iFp2j.getFunctionName)(handler)}\nError:`, e);
    }
}
function $eac0fdc9019e6986$var$instrumentCls() {
    return (0, $3a94cc11907d66f2$export$a7873055838e5ad8)((metric)=>{
        $eac0fdc9019e6986$var$triggerHandlers('cls', {
            metric: metric
        });
        $eac0fdc9019e6986$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $eac0fdc9019e6986$var$instrumentLcp() {
    return (0, $d19a62da7758f6a8$export$947b1626ab8d5632)((metric)=>{
        $eac0fdc9019e6986$var$triggerHandlers('lcp', {
            metric: metric
        });
        $eac0fdc9019e6986$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $eac0fdc9019e6986$var$instrumentTtfb() {
    return (0, $984e75d1a7843938$export$33a01e6c5f2c7e33)((metric)=>{
        $eac0fdc9019e6986$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $eac0fdc9019e6986$var$_previousTtfb = metric;
    });
}
function $eac0fdc9019e6986$var$instrumentInp() {
    return (0, $8a3e3089ba0d21a7$export$7df4b36ecaed99e1)((metric)=>{
        $eac0fdc9019e6986$var$triggerHandlers('inp', {
            metric: metric
        });
        $eac0fdc9019e6986$var$_previousInp = metric;
    });
}
function $eac0fdc9019e6986$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $eac0fdc9019e6986$var$addHandler(type, callback);
    let stopListening;
    if (!$eac0fdc9019e6986$var$instrumented[type]) {
        stopListening = instrumentFn();
        $eac0fdc9019e6986$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $eac0fdc9019e6986$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $eac0fdc9019e6986$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $4370472335afb2a9$export$d1203567a167490e)(type, (entries)=>{
        $eac0fdc9019e6986$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $eac0fdc9019e6986$var$addHandler(type, handler) {
    $eac0fdc9019e6986$var$handlers[type] = $eac0fdc9019e6986$var$handlers[type] || [];
    $eac0fdc9019e6986$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $eac0fdc9019e6986$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $eac0fdc9019e6986$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $eac0fdc9019e6986$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}



var $dHEV3 = parcelRequire("dHEV3");
var $iaBjX = parcelRequire("iaBjX");

var $bxVth = parcelRequire("bxVth");

/**
 * Checks if a given value is a valid measurement value.
 */ function $e59dd6874220a7cc$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $e59dd6874220a7cc$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $iaBjX.spanToJSON)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $07238d64f16b4415$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $07238d64f16b4415$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $e59dd6874220a7cc$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $dHEV3.getClient)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId();
    const scope = (0, $dHEV3.getCurrentScope)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (0, $bxVth.WINDOW).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        'client.address': sendDefaultPii ? '{{auto}}' : undefined,
        ...passedAttributes
    };
    return (0, $07238d64f16b4415$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $e59dd6874220a7cc$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $bxVth.WINDOW).addEventListener && (0, $bxVth.WINDOW).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $e59dd6874220a7cc$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $e59dd6874220a7cc$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
/**
 * Generic support check for web vitals
 */ function $e59dd6874220a7cc$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
/**
 * Listens for events on which we want to collect a previously accumulated web vital value.
 * Currently, this includes:
 *
 * - pagehide (i.e. user minimizes browser window, hides tab, etc)
 * - soft navigation (we only care about the vital of the initially loaded route)
 *
 * As a "side-effect", this function will also collect the span id of the pageload span.
 *
 * @param collectorCallback the callback to be called when the first of these events is triggered. Parameters:
 * - event: the event that triggered the reporting of the web vital value.
 * - pageloadSpanId: the span id of the pageload span. This is used to link the web vital span to the pageload span.
 */ function $e59dd6874220a7cc$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpanId;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpanId) collectorCallback(event, pageloadSpanId);
        collected = true;
    }
    (0, $331119233677988a$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce('pagehide');
    });
    const unsubscribeStartNavigation = client.on('beforeStartNavigationSpan', (_, options)=>{
        // we only want to collect LCP if we actually navigate. Redirects should be ignored.
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce('navigation');
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on('afterStartPageLoadSpan', (span)=>{
        pageloadSpanId = span.spanContext().spanId;
        unsubscribeAfterStartPageLoadSpan();
    });
}


/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $57dc90815d944345$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $e59dd6874220a7cc$export$c7533a7b4a9f2e94)('layout-shift')) return;
    const cleanupClsHandler = (0, $eac0fdc9019e6986$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $e59dd6874220a7cc$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $57dc90815d944345$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
/**
 * Exported only for testing!
 */ function $57dc90815d944345$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $5q5cQ.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(((0, $7Y1KN.browserPerformanceTimeOrigin)() || 0) + entry.startTime) : (0, $7Y1KN.timestampInSeconds)();
    const routeName = (0, $dHEV3.getCurrentScope)().getScopeData().transactionName;
    const name = entry ? (0, $dPLPm.htmlTreeAsString)(entry.sources[0]?.node) : 'Layout shift';
    const attributes = {
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser.cls',
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'ui.webvital.cls',
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId,
        // describes what triggered the web vital to be reported
        'sentry.report_event': reportEvent
    };
    // Add CLS sources as span attributes to help with debugging layout shifts
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift/sources
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $dPLPm.htmlTreeAsString)(source.node);
    });
    const span = (0, $e59dd6874220a7cc$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: '',
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}




var $7Y1KN = parcelRequire("7Y1KN");
var $w8bd7 = parcelRequire("w8bd7");
var $dHEV3 = parcelRequire("dHEV3");
var $dPLPm = parcelRequire("dPLPm");
var $gKbJW = parcelRequire("gKbJW");

var $5q5cQ = parcelRequire("5q5cQ");


/**
 * Starts tracking the Largest Contentful Paint on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop LCP measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the LCP value is sent as a standalone span and we stop
 * measuring LCP for subsequent routes.
 */ function $9121f4ad0b91bfb9$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $e59dd6874220a7cc$export$c7533a7b4a9f2e94)('largest-contentful-paint')) return;
    const cleanupLcpHandler = (0, $eac0fdc9019e6986$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $e59dd6874220a7cc$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $9121f4ad0b91bfb9$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
/**
 * Exported only for testing!
 */ function $9121f4ad0b91bfb9$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    (0, $5q5cQ.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(((0, $7Y1KN.browserPerformanceTimeOrigin)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $dHEV3.getCurrentScope)().getScopeData().transactionName;
    const name = entry ? (0, $dPLPm.htmlTreeAsString)(entry.element) : 'Largest contentful paint';
    const attributes = {
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser.lcp',
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'ui.webvital.lcp',
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: 0,
        // attach the pageload span id to the LCP span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId,
        // describes what triggered the web vital to be reported
        'sentry.report_event': reportEvent
    };
    if (entry) {
        entry.element && (attributes['lcp.element'] = (0, $dPLPm.htmlTreeAsString)(entry.element));
        entry.id && (attributes['lcp.id'] = entry.id);
        // Trim URL to the first 200 characters.
        entry.url && (attributes['lcp.url'] = entry.url.trim().slice(0, 200));
        // loadTime is the time of LCP that's related to receiving the LCP element response..
        entry.loadTime != null && (attributes['lcp.loadTime'] = entry.loadTime);
        // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        entry.renderTime != null && (attributes['lcp.renderTime'] = entry.renderTime);
        entry.size != null && (attributes['lcp.size'] = entry.size);
    }
    const span = (0, $e59dd6874220a7cc$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('lcp', {
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: 'millisecond',
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: lcpValue
        });
        // LCP is a point-in-time metric, so we end the span immediately
        span.end(startTime);
    }
}



var $7Y1KN = parcelRequire("7Y1KN");

function $ff9da0702c3578ce$var$getAbsoluteTime(time) {
    // falsy values should be preserved so that we can later on drop undefined values and
    // preserve 0 vals for cross-origin resources without proper `Timing-Allow-Origin` header.
    return time ? (((0, $7Y1KN.browserPerformanceTimeOrigin)() || performance.timeOrigin) + time) / 1000 : time;
}
/**
 * Converts a PerformanceResourceTiming entry to span data for the resource span. Most importantly,
 * it converts the timing values from timestamps relative to the `performance.timeOrigin` to absolute timestamps
 * in seconds.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming#timestamps
 *
 * @param resourceTiming
 * @returns An array where the first element is the attribute name and the second element is the attribute value.
 */ function $ff9da0702c3578ce$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    // Checking for only `undefined` and `null` is intentional because it's
    // valid for `nextHopProtocol` to be an empty string.
    if (resourceTiming.nextHopProtocol != undefined) {
        const { name: name, version: version } = (0, $e59dd6874220a7cc$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData['network.protocol.version'] = version;
        timingSpanData['network.protocol.name'] = name;
    }
    if (!((0, $7Y1KN.browserPerformanceTimeOrigin)() || (0, $e59dd6874220a7cc$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $ff9da0702c3578ce$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        'http.request.redirect_start': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.redirectStart),
        'http.request.redirect_end': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.redirectEnd),
        'http.request.worker_start': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.workerStart),
        'http.request.fetch_start': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.fetchStart),
        'http.request.domain_lookup_start': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        'http.request.domain_lookup_end': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        'http.request.connect_start': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.connectStart),
        'http.request.secure_connection_start': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        'http.request.connection_end': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.connectEnd),
        'http.request.request_start': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.requestStart),
        'http.request.response_start': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.responseStart),
        'http.request.response_end': $ff9da0702c3578ce$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        'http.request.time_to_first_byte': resourceTiming.responseStart != null ? resourceTiming.responseStart / 1000 : undefined
    });
}
/**
 * Remove properties with `undefined` as value from an object.
 * In contrast to `dropUndefinedKeys` in core this funciton only works on first-level
 * key-value objects and does not recursively go into object properties or arrays.
 */ function $ff9da0702c3578ce$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}






const $7205ea51a3b06ac0$var$MAX_INT_AS_BYTES = 2147483647;
let $7205ea51a3b06ac0$var$_performanceCursor = 0;
let $7205ea51a3b06ac0$var$_measurements = {};
let $7205ea51a3b06ac0$var$_lcpEntry;
let $7205ea51a3b06ac0$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $7205ea51a3b06ac0$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $e59dd6874220a7cc$export$f72a13c439a30cab)();
    if (performance && (0, $7Y1KN.browserPerformanceTimeOrigin)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $bxVth.WINDOW).performance.mark('sentry-tracing-init');
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $9121f4ad0b91bfb9$export$485112b2cb5f79dc)(client) : $7205ea51a3b06ac0$var$_trackLCP();
        const ttfbCleanupCallback = $7205ea51a3b06ac0$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $57dc90815d944345$export$585bab03c6c18c45)(client) : $7205ea51a3b06ac0$var$_trackCLS();
        return ()=>{
            lcpCleanupCallback?.();
            ttfbCleanupCallback();
            clsCleanupCallback?.();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $7205ea51a3b06ac0$export$f396d19077034ad2() {
    (0, $eac0fdc9019e6986$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        const parent = (0, $iaBjX.getActiveSpan)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $iaBjX.spanToJSON)(parent);
        for (const entry of entries){
            const startTime = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
            const duration = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $e59dd6874220a7cc$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $7205ea51a3b06ac0$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $iaBjX.getActiveSpan)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $iaBjX.spanToJSON)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $e59dd6874220a7cc$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $7205ea51a3b06ac0$export$e27543e0976315e4() {
    (0, $eac0fdc9019e6986$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        const parent = (0, $iaBjX.getActiveSpan)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
            const duration = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $dPLPm.htmlTreeAsString)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $dPLPm.getComponentName)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $e59dd6874220a7cc$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $7205ea51a3b06ac0$var$_trackCLS() {
    return (0, $eac0fdc9019e6986$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $7205ea51a3b06ac0$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $7205ea51a3b06ac0$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $7205ea51a3b06ac0$var$_trackLCP() {
    return (0, $eac0fdc9019e6986$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $7205ea51a3b06ac0$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $7205ea51a3b06ac0$var$_lcpEntry = entry;
    }, true);
}
function $7205ea51a3b06ac0$var$_trackTtfb() {
    return (0, $eac0fdc9019e6986$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $7205ea51a3b06ac0$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $7205ea51a3b06ac0$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $e59dd6874220a7cc$export$f72a13c439a30cab)();
    const origin = (0, $7Y1KN.browserPerformanceTimeOrigin)();
    if (!performance?.getEntries || !origin) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $iaBjX.spanToJSON)(span);
    performanceEntries.slice($7205ea51a3b06ac0$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $7205ea51a3b06ac0$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $7205ea51a3b06ac0$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, options.ignorePerformanceApiSpans);
                    // capture web vitals
                    const firstHidden = (0, $09e3e1b2860f2203$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $7205ea51a3b06ac0$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $7205ea51a3b06ac0$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $7205ea51a3b06ac0$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, options.ignoreResourceSpans);
                break;
        }
    });
    $7205ea51a3b06ac0$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $7205ea51a3b06ac0$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $7205ea51a3b06ac0$var$_addTtfbRequestTimeToMeasurements($7205ea51a3b06ac0$var$_measurements);
        // If CLS standalone spans are enabled, don't record CLS as a measurement
        if (!options.recordClsOnPageloadSpan) delete $7205ea51a3b06ac0$var$_measurements.cls;
        // If LCP standalone spans are enabled, don't record LCP as a measurement
        if (!options.recordLcpOnPageloadSpan) delete $7205ea51a3b06ac0$var$_measurements.lcp;
        Object.entries($7205ea51a3b06ac0$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $2174c183125e1337$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, $b55faa426ae84be6$export$d3e828b3c7b5b845)());
        $7205ea51a3b06ac0$var$_setWebVitalAttributes(span, options);
    }
    $7205ea51a3b06ac0$var$_lcpEntry = undefined;
    $7205ea51a3b06ac0$var$_clsEntry = undefined;
    $7205ea51a3b06ac0$var$_measurements = {};
}
/**
 * React 19.2+ creates performance.measure entries for component renders.
 * We can identify them by the `detail.devtools.track` property being set to 'Components ⚛'.
 * see: https://react.dev/reference/dev-tools/react-performance-tracks
 * see: https://github.com/facebook/react/blob/06fcc8f380c6a905c7bc18d94453f623cf8cbc81/packages/react-reconciler/src/ReactFiberPerformanceTrack.js#L454-L473
 */ function $7205ea51a3b06ac0$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== 'measure') return;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $7205ea51a3b06ac0$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($7205ea51a3b06ac0$var$isReact19MeasureEntry(entry)) return;
    if ([
        'mark',
        'measure'
    ].includes(entry.entryType) && (0, $kWdMm.stringMatchesSomePattern)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $8ead2cb8061fa04e$export$6431553786c94949)(false);
    const requestTime = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    $7205ea51a3b06ac0$var$_addDetailToSpanAttributes(attributes, entry);
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $e59dd6874220a7cc$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $7205ea51a3b06ac0$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        // Accessing detail might throw in some browsers (e.g., Firefox) due to security restrictions
        const detail = performanceMeasure.detail;
        if (!detail) return;
        // Process detail based on its type
        if (typeof detail === 'object') {
            // Handle object details
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $9ISAs.isPrimitive)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== undefined) try {
                    // This is user defined so we can't guarantee it's serializable
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {
                // Skip values that can't be stringified
                }
            }
            return;
        }
        if ((0, $9ISAs.isPrimitive)(detail)) {
            // Handle primitive details
            attributes['sentry.browser.measure.detail'] = detail;
            return;
        }
        try {
            attributes['sentry.browser.measure.detail'] = JSON.stringify(detail);
        } catch  {
        // Skip if stringification fails
        }
    } catch  {
    // Silently ignore any errors when accessing detail
    // This handles the Firefox "Permission denied to access object" error
    }
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function $7205ea51a3b06ac0$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $7205ea51a3b06ac0$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $7205ea51a3b06ac0$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $7205ea51a3b06ac0$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $7205ea51a3b06ac0$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $7205ea51a3b06ac0$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $7205ea51a3b06ac0$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $7205ea51a3b06ac0$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $e59dd6874220a7cc$export$7567a67bdb69a23d)(span, timeOrigin + (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics',
            ...event === 'redirect' && entry.redirectCount != null ? {
                'http.redirect_count': entry.redirectCount
            } : {}
        }
    });
}
function $7205ea51a3b06ac0$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $7205ea51a3b06ac0$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $e59dd6874220a7cc$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $e59dd6874220a7cc$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $7205ea51a3b06ac0$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other';
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.resource.browser.metrics'
    };
    const parsedUrl = (0, $f82Ej.parseUrl)(resourceUrl);
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $bxVth.WINDOW).location.origin);
    $7205ea51a3b06ac0$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            'responseStatus',
            'http.response.status_code'
        ],
        [
            'transferSize',
            'http.response_transfer_size'
        ],
        [
            'encodedBodySize',
            'http.response_content_length'
        ],
        [
            'decodedBodySize',
            'http.decoded_response_content_length'
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            'renderBlockingStatus',
            'resource.render_blocking_status'
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            'deliveryType',
            'http.response_delivery_type'
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $ff9da0702c3578ce$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $e59dd6874220a7cc$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $bxVth.WINDOW).location.origin, ''),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
/**
 * Capture the information of the user agent.
 */ function $7205ea51a3b06ac0$var$_trackNavigator(span) {
    const navigator = (0, $bxVth.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $e59dd6874220a7cc$export$27169ccae1b439e3)(connection.rtt)) $7205ea51a3b06ac0$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $e59dd6874220a7cc$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $e59dd6874220a7cc$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $7205ea51a3b06ac0$var$_setWebVitalAttributes(span, options) {
    // Only add LCP attributes if LCP is being recorded on the pageload span
    if ($7205ea51a3b06ac0$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($7205ea51a3b06ac0$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $dPLPm.htmlTreeAsString)($7205ea51a3b06ac0$var$_lcpEntry.element));
        if ($7205ea51a3b06ac0$var$_lcpEntry.id) span.setAttribute('lcp.id', $7205ea51a3b06ac0$var$_lcpEntry.id);
        if ($7205ea51a3b06ac0$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $7205ea51a3b06ac0$var$_lcpEntry.url.trim().slice(0, 200));
        if ($7205ea51a3b06ac0$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $7205ea51a3b06ac0$var$_lcpEntry.loadTime);
        if ($7205ea51a3b06ac0$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $7205ea51a3b06ac0$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $7205ea51a3b06ac0$var$_lcpEntry.size);
    }
    // Only add CLS attributes if CLS is being recorded on the pageload span
    if ($7205ea51a3b06ac0$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $7205ea51a3b06ac0$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $dPLPm.htmlTreeAsString)(source.node)));
}
/**
 * Use this to set any attributes we can take directly form the PerformanceResourceTiming entry.
 *
 * This is just a mapping function for entry->attribute to keep bundle-size minimal.
 * Experimental properties are also accepted (see {@link ExperimentalResourceTimingProperty}).
 * Assumes that all entry properties might be undefined for browser-specific differences.
 * Only accepts string and number values for now and also sets 0-values.
 */ function $7205ea51a3b06ac0$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === 'number' && entryVal < $7205ea51a3b06ac0$var$MAX_INT_AS_BYTES || typeof entryVal === 'string')) attributes[attributeKey] = entryVal;
    });
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $7205ea51a3b06ac0$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $8ead2cb8061fa04e$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}


var $7Y1KN = parcelRequire("7Y1KN");
var $iaBjX = parcelRequire("iaBjX");
var $dHEV3 = parcelRequire("dHEV3");
var $dPLPm = parcelRequire("dPLPm");
var $gKbJW = parcelRequire("gKbJW");


const $d3f84b518287c57a$var$LAST_INTERACTIONS = [];
const $d3f84b518287c57a$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * 60 seconds is the maximum for a plausible INP value
 * (source: Me)
 */ const $d3f84b518287c57a$var$MAX_PLAUSIBLE_INP_DURATION = 60;
/**
 * Start tracking INP webvital events.
 */ function $d3f84b518287c57a$export$f17d06681a4744a3() {
    const performance = (0, $e59dd6874220a7cc$export$f72a13c439a30cab)();
    if (performance && (0, $7Y1KN.browserPerformanceTimeOrigin)()) {
        const inpCallback = $d3f84b518287c57a$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $d3f84b518287c57a$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. #
 * exported only for testing
 */ function $d3f84b518287c57a$export$eeab203db0ed99a9() {
    return (0, $eac0fdc9019e6986$export$da3b76aa2022cbd7)($d3f84b518287c57a$export$7bcb98fe01441521);
}
/**
 * exported only for testing
 */ const $d3f84b518287c57a$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == undefined) return;
    const duration = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(metric.value);
    // We received occasional reports of hour-long INP values.
    // Therefore, we add a sanity check to avoid creating spans for
    // unrealistically long INP durations.
    if (duration > $d3f84b518287c57a$var$MAX_PLAUSIBLE_INP_DURATION) return;
    const entry = metric.entries.find((entry)=>entry.duration === metric.value && $d3f84b518287c57a$var$INP_ENTRY_MAP[entry.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $d3f84b518287c57a$var$INP_ENTRY_MAP[entry.name];
    /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
    const activeSpan = (0, $iaBjX.getActiveSpan)();
    const rootSpan = activeSpan ? (0, $iaBjX.getRootSpan)(activeSpan) : undefined;
    // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
    // where we cache the route per interactionId
    const cachedSpan = interactionId != null ? $d3f84b518287c57a$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
    const spanToUse = cachedSpan || rootSpan;
    // Else, we try to use the active span.
    // Finally, we fall back to look at the transactionName on the scope
    const routeName = spanToUse ? (0, $iaBjX.spanToJSON)(spanToUse).description : (0, $dHEV3.getCurrentScope)().getScopeData().transactionName;
    const name = (0, $dPLPm.htmlTreeAsString)(entry.target);
    const attributes = {
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser.inp',
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: `ui.interaction.${interactionType}`,
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry.duration
    };
    const span = (0, $e59dd6874220a7cc$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('inp', {
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: 'millisecond',
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: metric.value
        });
        span.end(startTime + duration);
    }
};
/**
 * Register a listener to cache route information for INP interactions.
 */ function $d3f84b518287c57a$export$e4e04d43e223cce2() {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $iaBjX.getActiveSpan)();
        const activeRootSpan = activeSpan && (0, $iaBjX.getRootSpan)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $eac0fdc9019e6986$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($d3f84b518287c57a$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($d3f84b518287c57a$var$LAST_INTERACTIONS.length > 10) {
                const last = $d3f84b518287c57a$var$LAST_INTERACTIONS.shift();
                $d3f84b518287c57a$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $d3f84b518287c57a$var$LAST_INTERACTIONS.push(interactionId);
            $d3f84b518287c57a$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $eac0fdc9019e6986$export$69816c1a049f8db6)('event', handleEntries);
    (0, $eac0fdc9019e6986$export$69816c1a049f8db6)('first-input', handleEntries);
}


var $7Y1KN = parcelRequire("7Y1KN");
var $iaBjX = parcelRequire("iaBjX");
var $dHEV3 = parcelRequire("dHEV3");
var $gKbJW = parcelRequire("gKbJW");


// ElementTiming interface based on the W3C spec
/**
 * Start tracking ElementTiming performance entries.
 */ function $3703ed44445be468$export$c9ffcf7e2b5ec1b3() {
    const performance = (0, $e59dd6874220a7cc$export$f72a13c439a30cab)();
    if (performance && (0, $7Y1KN.browserPerformanceTimeOrigin)()) return (0, $eac0fdc9019e6986$export$69816c1a049f8db6)('element', $3703ed44445be468$export$2f1fb99ea19ed53a);
    return ()=>undefined;
}
/**
 * exported only for testing
 */ const $3703ed44445be468$export$2f1fb99ea19ed53a = ({ entries: entries })=>{
    const activeSpan = (0, $iaBjX.getActiveSpan)();
    const rootSpan = activeSpan ? (0, $iaBjX.getRootSpan)(activeSpan) : undefined;
    const transactionName = rootSpan ? (0, $iaBjX.spanToJSON)(rootSpan).description : (0, $dHEV3.getCurrentScope)().getScopeData().transactionName;
    entries.forEach((entry)=>{
        const elementEntry = entry;
        // Skip entries without identifier (elementtiming attribute)
        if (!elementEntry.identifier) return;
        // `name` contains the type of the element paint. Can be `'image-paint'` or `'text-paint'`.
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceElementTiming#instance_properties
        const paintType = elementEntry.name;
        const renderTime = elementEntry.renderTime;
        const loadTime = elementEntry.loadTime;
        // starting the span at:
        // - `loadTime` if available (should be available for all "image-paint" entries, 0 otherwise)
        // - `renderTime` if available (available for all entries, except 3rd party images, but these should be covered by `loadTime`, 0 otherwise)
        // - `timestampInSeconds()` as a safeguard
        // see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceElementTiming/renderTime#cross-origin_image_render_time
        const [spanStartTime, spanStartTimeSource] = loadTime ? [
            (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(loadTime),
            'load-time'
        ] : renderTime ? [
            (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(renderTime),
            'render-time'
        ] : [
            (0, $7Y1KN.timestampInSeconds)(),
            'entry-emission'
        ];
        const duration = paintType === 'image-paint' ? // and `renderTime`. `loadTime` is the time when the image finished loading and `renderTime` is the
        // time when the image finished rendering.
        (0, $e59dd6874220a7cc$export$b4785dbd4a81b33f)(Math.max(0, (renderTime ?? 0) - (loadTime ?? 0))) : 0;
        const attributes = {
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.elementtiming',
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'ui.elementtiming',
            // name must be user-entered, so we can assume low cardinality
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'component',
            // recording the source of the span start time, as it varies depending on available data
            'sentry.span_start_time_source': spanStartTimeSource,
            'sentry.transaction_name': transactionName,
            'element.id': elementEntry.id,
            'element.type': elementEntry.element?.tagName?.toLowerCase() || 'unknown',
            'element.size': elementEntry.naturalWidth && elementEntry.naturalHeight ? `${elementEntry.naturalWidth}x${elementEntry.naturalHeight}` : undefined,
            'element.render_time': renderTime,
            'element.load_time': loadTime,
            // `url` is `0`(number) for text paints (hence we fall back to undefined)
            'element.url': elementEntry.url || undefined,
            'element.identifier': elementEntry.identifier,
            'element.paint_type': paintType
        };
        (0, $07238d64f16b4415$export$a1bd95187356f372)({
            name: `element[${elementEntry.identifier}]`,
            attributes: attributes,
            startTime: spanStartTime,
            onlyIfParent: true
        }, (span)=>{
            span.end(spanStartTime + duration);
        });
    });
};



var $2sCie = parcelRequire("2sCie");

var $bC06r = parcelRequire("bC06r");

var $w8bd7 = parcelRequire("w8bd7");
var $iaBjX = parcelRequire("iaBjX");
var $cDZNc = parcelRequire("cDZNc");

var $2sCie = parcelRequire("2sCie");

var $bC06r = parcelRequire("bC06r");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $839feea5e49ef2eb$export$6f18f55521af71a1() {
    if ((0, $bC06r.WINDOW).document) (0, $bC06r.WINDOW).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $iaBjX.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $iaBjX.getRootSpan)(activeSpan);
        if ((0, $bC06r.WINDOW).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $iaBjX.spanToJSON)(rootSpan);
            if (0, $2sCie.DEBUG_BUILD) (0, $w8bd7.debug).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $cDZNc.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}



var $w8bd7 = parcelRequire("w8bd7");
var $dHEV3 = parcelRequire("dHEV3");
var $iaBjX = parcelRequire("iaBjX");
var $gKbJW = parcelRequire("gKbJW");

var $2sCie = parcelRequire("2sCie");

var $bC06r = parcelRequire("bC06r");








// 1h in seconds
const $23fc3a28ff260832$export$c8d616af96ac729f = 3600;
// session storage key
const $23fc3a28ff260832$export$16b6aa13b3c0f075 = 'sentry_previous_trace';
const $23fc3a28ff260832$export$237518aee8726f02 = 'sentry.previous_trace';
/**
 * Takes care of linking traces and applying the (consistent) sampling behavoiour based on the passed options
 * @param options - options for linking traces and consistent trace sampling (@see BrowserTracingOptions)
 * @param client - Sentry client
 */ function $23fc3a28ff260832$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === 'session-storage';
    let inMemoryPreviousTraceInfo = useSessionStorage ? $23fc3a28ff260832$export$ef546bba8a402d99() : undefined;
    client.on('spanStart', (span)=>{
        if ((0, $iaBjX.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $dHEV3.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $23fc3a28ff260832$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $23fc3a28ff260832$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) /*
    When users opt into `consistentTraceSampling`, we need to ensure that we propagate
    the previous trace's sample rate and rand to the current trace. This is necessary because otherwise, span
    metric extrapolation is inaccurate, as we'd propagate too high of a sample rate for the subsequent traces.

    So therefore, we pretend that the previous trace was the parent trace of the newly started trace. To do that,
    we mutate the propagation context of the current trace and set the sample rate and sample rand of the previous trace.
    Timing-wise, it is fine because it happens before we even sample the root span.

    @see https://github.com/getsentry/sentry-javascript/issues/15754
    */ client.on('beforeSampling', (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $dHEV3.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        // We do not want to force-continue the sampling decision if we continue a trace
        // that was started on the backend. Most prominently, this will happen in MPAs where
        // users hard-navigate between pages. In this case, the sampling decision of a potentially
        // started trace on the server takes precedence.
        // Why? We want to prioritize inter-trace consistency over intra-trace consistency.
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($23fc3a28ff260832$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $23fc3a28ff260832$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function $23fc3a28ff260832$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $iaBjX.spanToJSON)(span);
    function getSampleRate() {
        try {
            return Number(oldPropagationContext.dsc?.sample_rate) ?? Number(spanJson.data?.[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]);
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= $23fc3a28ff260832$export$c8d616af96ac729f) {
        if (0, $2sCie.DEBUG_BUILD) (0, $w8bd7.debug).log(`Adding previous_trace ${previousTraceSpanCtx} link to span ${{
            op: spanJson.op,
            ...span.spanContext()
        }}`);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $gKbJW.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: 'previous_trace'
            }
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v11), to remind us
        // to check this at v11 time :)
        span.setAttribute($23fc3a28ff260832$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$23fc3a28ff260832$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function $23fc3a28ff260832$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $bC06r.WINDOW).sessionStorage.setItem($23fc3a28ff260832$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Could not store previous trace in sessionStorage', e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function $23fc3a28ff260832$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $bC06r.WINDOW).sessionStorage?.getItem($23fc3a28ff260832$export$16b6aa13b3c0f075);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch  {
        return undefined;
    }
}
/**
 * see {@link import('@sentry/core').spanIsSampled}
 */ function $23fc3a28ff260832$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 0x1;
}



var $gfqT4 = parcelRequire("gfqT4");
var $iaBjX = parcelRequire("iaBjX");
var $dHEV3 = parcelRequire("dHEV3");
var $dPLPm = parcelRequire("dPLPm");
var $dO8ql = parcelRequire("dO8ql");

var $2vdTp = parcelRequire("2vdTp");

var $dHEV3 = parcelRequire("dHEV3");

var $cPuNx = parcelRequire("cPuNx");

var $w8bd7 = parcelRequire("w8bd7");

var $iaBjX = parcelRequire("iaBjX");

var $7oIfw = parcelRequire("7oIfw");

var $7Fxjp = parcelRequire("7Fxjp");

var $jeERW = parcelRequire("jeERW");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * If (@param options.propagateTraceparent) is `true`, the function will also generate a `traceparent` value,
 * following the W3C traceparent header format.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $ace0ff3d79a4f1f1$export$dec8f001b9d982cb(options = {}) {
    const client = options.client || (0, $dHEV3.getClient)();
    if (!(0, $cPuNx.isEnabled)() || !client) return {};
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $dO8ql.getAsyncContextStrategy)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || (0, $dHEV3.getCurrentScope)();
    const span = options.span || (0, $iaBjX.getActiveSpan)();
    const sentryTrace = span ? (0, $iaBjX.spanToTraceHeader)(span) : $ace0ff3d79a4f1f1$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $7oIfw.getDynamicSamplingContextFromSpan)(span) : (0, $7oIfw.getDynamicSamplingContextFromScope)(client, scope);
    const baggage = (0, $7Fxjp.dynamicSamplingContextToSentryBaggageHeader)(dsc);
    const isValidSentryTraceHeader = (0, $jeERW.TRACEPARENT_REGEXP).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $w8bd7.debug).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    const traceData = {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
    if (options.propagateTraceparent) {
        const traceparent = span ? (0, $iaBjX.spanToTraceparentHeader)(span) : $ace0ff3d79a4f1f1$var$scopeToTraceparentHeader(scope);
        if (traceparent) traceData.traceparent = traceparent;
    }
    return traceData;
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $ace0ff3d79a4f1f1$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $jeERW.generateSentryTraceHeader)(traceId, propagationSpanId, sampled);
}
function $ace0ff3d79a4f1f1$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $jeERW.generateTraceparentHeader)(traceId, propagationSpanId, sampled);
}


var $B8qZj = parcelRequire("B8qZj");
var $dHEV3 = parcelRequire("dHEV3");

var $gKbJW = parcelRequire("gKbJW");

var $iaBjX = parcelRequire("iaBjX");

var $cDZNc = parcelRequire("cDZNc");

var $9ISAs = parcelRequire("9ISAs");

var $B8qZj = parcelRequire("B8qZj");

var $7Fxjp = parcelRequire("7Fxjp");




var $f82Ej = parcelRequire("f82Ej");
/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $169530c1e4c27020$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, $B8qZj.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $169530c1e4c27020$var$endSpan(span, handlerData);
            $169530c1e4c27020$export$740b7cef1e5753d5(span, handlerData, spanOriginOrOptions);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    // Backwards-compatible with the old signature. Needed to introduce the combined optional parameter
    // to avoid API breakage for anyone calling this function with the optional spanOrigin parameter
    // TODO (v11): remove this backwards-compatible code and only accept the options parameter
    const { spanOrigin: spanOrigin = 'auto.http.browser', propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === 'object' ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const hasParent = !!(0, $iaBjX.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $07238d64f16b4415$export$63dbba021a6b4047)($169530c1e4c27020$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $427ccfee27d19206$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $169530c1e4c27020$export$eab8901e1b084464(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $B8qZj.hasSpansEnabled)() && hasParent ? span : undefined, propagateTraceparent);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    const client = (0, $dHEV3.getClient)();
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit('beforeOutgoingRequestSpan', span, fetchHint);
    }
    return span;
}
/**
 * Calls the onRequestSpanEnd callback if it is defined.
 */ function $169530c1e4c27020$export$740b7cef1e5753d5(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === 'object' && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : undefined;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 * exported only for testing purposes
 *
 * When we determine if we should add a baggage header, there are 3 cases:
 * 1. No previous baggage header -> add baggage
 * 2. Previous baggage header has no sentry baggage values -> add our baggage
 * 3. Previous baggage header has sentry baggage values -> do nothing (might have been added manually by users)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function $169530c1e4c27020$export$eab8901e1b084464(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = (0, $ace0ff3d79a4f1f1$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const originalHeaders = fetchOptionsObj.headers || ((0, $9ISAs.isRequest)(request) ? request.headers : undefined);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($169530c1e4c27020$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get('sentry-trace')) newHeaders.set('sentry-trace', sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get('traceparent')) newHeaders.set('traceparent', traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (!prevBaggageHeader) newHeaders.set('baggage', baggage);
            else if (!$169530c1e4c27020$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set('baggage', `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if (Array.isArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!originalHeaders.find((header)=>header[0] === 'sentry-trace')) newHeaders.push([
            'sentry-trace',
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !originalHeaders.find((header)=>header[0] === 'traceparent')) newHeaders.push([
            'traceparent',
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === 'baggage' && $169530c1e4c27020$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = 'sentry-trace' in originalHeaders ? originalHeaders['sentry-trace'] : undefined;
        const existingTraceparentHeader = 'traceparent' in originalHeaders ? originalHeaders.traceparent : undefined;
        const existingBaggageHeader = 'baggage' in originalHeaders ? originalHeaders.baggage : undefined;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$169530c1e4c27020$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $169530c1e4c27020$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = {
            ...originalHeaders,
            'sentry-trace': existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $169530c1e4c27020$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $cDZNc.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $cDZNc.SPAN_STATUS_ERROR),
        message: 'internal_error'
    });
    span.end();
}
function $169530c1e4c27020$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',').some((baggageEntry)=>baggageEntry.trim().startsWith((0, $7Fxjp.SENTRY_BAGGAGE_KEY_PREFIX)));
}
function $169530c1e4c27020$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, $9ISAs.isInstanceOf)(headers, Headers);
}
function $169530c1e4c27020$var$getSpanStartOptions(url, method, spanOrigin) {
    const parsedUrl = (0, $f82Ej.parseStringToURLObject)(url);
    return {
        name: parsedUrl ? `${method} ${(0, $f82Ej.getSanitizedUrlStringFromUrlObject)(parsedUrl)}` : method,
        attributes: $169530c1e4c27020$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $169530c1e4c27020$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: url,
        type: 'fetch',
        'http.method': method,
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'http.client'
    };
    if (parsedUrl) {
        if (!(0, $f82Ej.isURLObjectRelative)(parsedUrl)) {
            attributes['http.url'] = parsedUrl.href;
            attributes['server.address'] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes['http.query'] = parsedUrl.search;
        if (parsedUrl.hash) attributes['http.fragment'] = parsedUrl.hash;
    }
    return attributes;
}


var $f82Ej = parcelRequire("f82Ej");
var $gKbJW = parcelRequire("gKbJW");
var $cDZNc = parcelRequire("cDZNc");
var $kWdMm = parcelRequire("kWdMm");

var $9X7xs = parcelRequire("9X7xs");
var $w8bd7 = parcelRequire("w8bd7");

var $5q5cQ = parcelRequire("5q5cQ");
/**
 * Serializes FormData.
 *
 * This is a bit simplified, but gives us a decent estimate.
 * This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'.
 *
 */ function $d90042f398424316$export$2f1b0f57f243f270(formData) {
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
/** Get the string representation of a body. */ function $d90042f398424316$export$945a2d5364608d5(body, _debug = (0, $w8bd7.debug)) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $d90042f398424316$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        (0, $5q5cQ.DEBUG_BUILD) && _debug.error(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    (0, $5q5cQ.DEBUG_BUILD) && _debug.log('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/**
 * Parses the fetch arguments to extract the request payload.
 *
 * We only support getting the body from the fetch options.
 */ function $d90042f398424316$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
/**
 * Parses XMLHttpRequest response headers into a Record.
 * Extracted from replay internals to be reusable.
 */ function $d90042f398424316$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $5q5cQ.DEBUG_BUILD) && (0, $w8bd7.debug).error(error, 'Failed to get xhr response headers', xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



var $bC06r = parcelRequire("bC06r");
/**
 * Checks if the baggage header has Sentry values.
 */ function $47c9636a131e0c56$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(',').some((value)=>value.trim().startsWith('sentry-'));
}
/**
 * Gets the full URL from a given URL string.
 */ function $47c9636a131e0c56$export$f2a087db7564c909(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $bC06r.WINDOW).location.origin);
        return parsed.href;
    } catch  {
        return undefined;
    }
}
/**
 * Checks if the entry is a PerformanceResourceTiming.
 */ function $47c9636a131e0c56$export$5803eedf1027ce61(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a Headers object from a record of string key-value pairs, and returns undefined if it fails.
 */ function $47c9636a131e0c56$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        // noop
        return undefined;
    }
}


/** Options for Request Instrumentation */ const $4c147e43bbf7ebc1$var$responseToSpanId = new WeakMap();
const $4c147e43bbf7ebc1$var$spanIdToEndTimestamp = new Map();
const $4c147e43bbf7ebc1$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $4c147e43bbf7ebc1$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$4c147e43bbf7ebc1$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$4c147e43bbf7ebc1$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $4c147e43bbf7ebc1$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $4c147e43bbf7ebc1$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $gfqT4.addFetchEndInstrumentationHandler)((handlerData)=>{
            if (handlerData.response) {
                const span = $4c147e43bbf7ebc1$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $4c147e43bbf7ebc1$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $gfqT4.addFetchInstrumentationHandler)((handlerData)=>{
            const createdSpan = (0, $169530c1e4c27020$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
                propagateTraceparent: propagateTraceparent,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (handlerData.response && handlerData.fetchData.__span) $4c147e43bbf7ebc1$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = (0, $47c9636a131e0c56$export$f2a087db7564c909)(handlerData.fetchData.url);
                const host = fullUrl ? (0, $f82Ej.parseUrl)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl,
                    'server.address': host
                });
                if (enableHTTPTimings) $4c147e43bbf7ebc1$var$addHTTPTimings(createdSpan);
                onRequestSpanStart?.(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, $9X7xs.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $4c147e43bbf7ebc1$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $4c147e43bbf7ebc1$var$addHTTPTimings(createdSpan);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $47c9636a131e0c56$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $4c147e43bbf7ebc1$var$addHTTPTimings(span) {
    const { url: url } = (0, $iaBjX.spanToJSON)(span).data;
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $eac0fdc9019e6986$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $47c9636a131e0c56$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $ff9da0702c3578ce$export$ec50b091612e7e00)(entry));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $4c147e43bbf7ebc1$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $dPLPm.getLocationHref)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $kWdMm.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $kWdMm.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $kWdMm.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $4c147e43bbf7ebc1$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $9X7xs.SENTRY_XHR_DATA_KEY];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $B8qZj.hasSpansEnabled)() && shouldCreateSpan(url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $cDZNc.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            onRequestSpanEnd?.(span, {
                headers: (0, $47c9636a131e0c56$export$9dc5b8b2fb320da0)((0, $d90042f398424316$export$ce71c337afb62ea)(xhr)),
                error: handlerData.error
            });
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = (0, $47c9636a131e0c56$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $f82Ej.parseUrl)(fullUrl) : (0, $f82Ej.parseUrl)(url);
    const urlForSpanName = (0, $f82Ej.stripUrlQueryAndFragment)(url);
    const hasParent = !!(0, $iaBjX.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $07238d64f16b4415$export$63dbba021a6b4047)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: url,
            type: 'xhr',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': parsedUrl?.host,
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser',
            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'http.client',
            ...parsedUrl?.search && {
                'http.query': parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                'http.fragment': parsedUrl?.hash
            }
        }
    }) : new (0, $427ccfee27d19206$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(url)) $4c147e43bbf7ebc1$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $B8qZj.hasSpansEnabled)() && hasParent ? span : undefined, propagateTraceparent);
    const client = (0, $dHEV3.getClient)();
    if (client) client.emit('beforeOutgoingRequestSpan', span, handlerData);
    return span;
}
function $4c147e43bbf7ebc1$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { 'sentry-trace': sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $ace0ff3d79a4f1f1$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $4c147e43bbf7ebc1$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $4c147e43bbf7ebc1$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.['sentry-trace'] || !xhr.setRequestHeader) // bail if a sentry-trace header is already set
    return;
    try {
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.['traceparent']) xhr.setRequestHeader('traceparent', traceparentHeader);
        if (sentryBaggageHeader) {
            // only add our headers if
            // - no pre-existing baggage header exists
            // - or it is set and doesn't yet contain sentry values
            const originalBaggageHeader = originalHeaders?.['baggage'];
            if (!originalBaggageHeader || !(0, $47c9636a131e0c56$export$8193ac587e359dc0)(originalBaggageHeader)) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            xhr.setRequestHeader('baggage', sentryBaggageHeader);
        }
    } catch  {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}


const $417f53d2be130055$export$bbd2089f30bd3708 = 'BrowserTracing';
const $417f53d2be130055$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $457bc1d0cff66550$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    enableElementTiming: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: 'in-memory',
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $4c147e43bbf7ebc1$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $417f53d2be130055$export$b4109253475213e9 = (options = {})=>{
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $bC06r.WINDOW).document;
    const { enableInp: enableInp, enableElementTiming: enableElementTiming, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$417f53d2be130055$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    let _collectWebVitals;
    let lastInteractionTimestamp;
    let _pageloadSpan;
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions, makeActive = true) {
        const isPageloadSpan = startSpanOptions.op === 'pageload';
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (initialSpanName !== finalStartSpanOptions.name) {
            attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        if (!makeActive) {
            // We want to ensure this has 0s duration
            const now = (0, $7Y1KN.dateTimestampInSeconds)();
            (0, $07238d64f16b4415$export$63dbba021a6b4047)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $457bc1d0cff66550$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                // This will generally always be defined here, because it is set in `setup()` of the integration
                // but technically, it is optional, so we guard here to be extra safe
                _collectWebVitals?.();
                (0, $7205ea51a3b06ac0$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans,
                    recordLcpOnPageloadSpan: !enableStandaloneLcpSpans,
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans
                });
                $417f53d2be130055$var$setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                const scope = (0, $dHEV3.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $iaBjX.spanIsSampled)(idleSpan),
                    dsc: (0, $7oIfw.getDynamicSamplingContextFromSpan)(span)
                });
                if (isPageloadSpan) // clean up the stored pageload span on the intergration.
                _pageloadSpan = undefined;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $417f53d2be130055$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                'interactive',
                'complete'
            ].includes(optionalWindowDocument.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        // Enable auto finish of the pageload span if users are not explicitly ending it
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $417f53d2be130055$export$bbd2089f30bd3708,
        setup (client) {
            (0, $ae410015a73adcb9$export$b0914730ee1f6c80)();
            _collectWebVitals = (0, $7205ea51a3b06ac0$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: enableStandaloneClsSpans || false,
                recordLcpStandaloneSpans: enableStandaloneLcpSpans || false,
                client: client
            });
            if (enableInp) (0, $d3f84b518287c57a$export$f17d06681a4744a3)();
            if (enableElementTiming) (0, $3703ed44445be468$export$c9ffcf7e2b5ec1b3)();
            if (enableLongAnimationFrame && (0, $bZENS.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) (0, $7205ea51a3b06ac0$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $7205ea51a3b06ac0$export$f396d19077034ad2)();
            if (enableInteractions) (0, $7205ea51a3b06ac0$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $7Y1KN.timestampInSeconds)();
                };
                addEventListener('click', interactionHandler, {
                    capture: true
                });
                addEventListener('keydown', interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $417f53d2be130055$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $iaBjX.spanToJSON)(activeSpan).timestamp) {
                    (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).log(`[Tracing] Finishing current active span with op: ${(0, $iaBjX.spanToJSON)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.setAttribute((0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'cancelled');
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions, navigationOptions)=>{
                if ((0, $dHEV3.getClient)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).warn('[Tracing] Detected redirect, navigation span will not be the root span, but a child span.');
                    _createRouteSpan(client, {
                        op: 'navigation.redirect',
                        ...startSpanOptions
                    }, false);
                    return;
                }
                // Reset the last interaction timestamp since we now start a new navigation.
                // Any subsequent navigation span starts could again be a redirect, so we
                // should reset our heuristic detectors.
                lastInteractionTimestamp = undefined;
                maybeEndActiveSpan();
                (0, $dHEV3.getIsolationScope)().setPropagationContext({
                    traceId: (0, $arYTK.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $B8qZj.hasSpansEnabled)() ? undefined : (0, $arYTK.generateSpanId)()
                });
                const scope = (0, $dHEV3.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $arYTK.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $B8qZj.hasSpansEnabled)() ? undefined : (0, $arYTK.generateSpanId)()
                });
                // We reset this to ensure we do not have lingering incorrect data here
                // places that call this hook may set this where appropriate - else, the URL at span sending time is used
                scope.setSDKProcessingMetadata({
                    normalizedRequest: undefined
                });
                _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $dHEV3.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $417f53d2be130055$export$f147b32b03c9cf11('sentry-trace');
                const baggage = traceOptions.baggage || $417f53d2be130055$export$f147b32b03c9cf11('baggage');
                const propagationContext = (0, $jeERW.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $dHEV3.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $B8qZj.hasSpansEnabled)()) // for browser, we wanna keep the spanIds consistent during the entire lifetime of the trace
                // this works by setting the propagationSpanId to a random spanId so that we have a consistent
                // span id to propagate in TwP mode (!hasSpansEnabled())
                scope.getPropagationContext().propagationSpanId = (0, $arYTK.generateSpanId)();
                // We store the normalized request data on the scope, so we get the request data at time of span creation
                // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $bC06r.getHttpRequestData)()
                });
                _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
            client.on('endPageloadSpan', ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'reportPageLoaded');
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            let startingUrl = (0, $dPLPm.getLocationHref)();
            if (linkPreviousTrace !== 'off') (0, $23fc3a28ff260832$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $bC06r.WINDOW).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $7Y1KN.browserPerformanceTimeOrigin)();
                    $417f53d2be130055$export$aa44a07f82af519f(client, {
                        name: (0, $bC06r.WINDOW).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: {
                            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url',
                            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.pageload.browser'
                        }
                    });
                }
                if (instrumentNavigation) (0, $3kfyQ.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    startingUrl = undefined;
                    const parsed = (0, $f82Ej.parseStringToURLObject)(to);
                    const activeSpan = $417f53d2be130055$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $417f53d2be130055$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $417f53d2be130055$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $bC06r.WINDOW).location.pathname,
                        attributes: {
                            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url',
                            [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.navigation.browser'
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $839feea5e49ef2eb$export$6f18f55521af71a1)();
            if (enableInteractions) $417f53d2be130055$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $d3f84b518287c57a$export$e4e04d43e223cce2)();
            (0, $4c147e43bbf7ebc1$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $417f53d2be130055$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $dHEV3.getCurrentScope)().setTransactionName(spanOptions.name);
    const pageloadSpan = $417f53d2be130055$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit('afterStartPageLoadSpan', pageloadSpan);
    return pageloadSpan;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $417f53d2be130055$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect } = options || {};
    client.emit('beforeStartNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    client.emit('startNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    const scope = (0, $dHEV3.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    // We store the normalized request data on the scope, so we get the request data at time of span creation
    // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
    if (url && !isRedirect) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $bC06r.getHttpRequestData)(),
            url: url
        }
    });
    return $417f53d2be130055$var$getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function $417f53d2be130055$export$f147b32b03c9cf11(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $bC06r.WINDOW).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute('content') || undefined;
}
/** Start listener for interaction transactions */ function $417f53d2be130055$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $bC06r.WINDOW).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeIdleSpan = $417f53d2be130055$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $iaBjX.spanToJSON)(activeIdleSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $457bc1d0cff66550$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener('click', registerInteractionTransaction, {
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
const $417f53d2be130055$var$ACTIVE_IDLE_SPAN_PROPERTY = '_sentry_idleSpan';
function $417f53d2be130055$var$getActiveIdleSpan(client) {
    return client[$417f53d2be130055$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $417f53d2be130055$var$setActiveIdleSpan(client, span) {
    (0, $4zVoD.addNonEnumerableProperty)(client, $417f53d2be130055$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
// The max. time in seconds between two pageload/navigation spans that makes us consider the second one a redirect
const $417f53d2be130055$var$REDIRECT_THRESHOLD = 1.5;
function $417f53d2be130055$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $iaBjX.spanToJSON)(activeSpan);
    const now = (0, $7Y1KN.dateTimestampInSeconds)();
    // More than REDIRECT_THRESHOLD seconds since last navigation/pageload span?
    // --> never consider this a redirect
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $417f53d2be130055$var$REDIRECT_THRESHOLD) return false;
    // A click happened in the last REDIRECT_THRESHOLD seconds?
    // --> never consider this a redirect
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $417f53d2be130055$var$REDIRECT_THRESHOLD) return false;
    return true;
}


var $dHEV3 = parcelRequire("dHEV3");

var $cPuNx = parcelRequire("cPuNx");

var $6gxho = parcelRequire("6gxho");

var $j1zPl = parcelRequire("j1zPl");

var $w8bd7 = parcelRequire("w8bd7");

var $h9p4m = parcelRequire("h9p4m");

var $dOy0j = parcelRequire("dOy0j");

var $kWdMm = parcelRequire("kWdMm");

var $bZENS = parcelRequire("bZENS");
const $6d877d60f0d82988$var$INTEGRATION_NAME = 'CaptureConsole';
const $6d877d60f0d82988$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $w8bd7.CONSOLE_LEVELS);
    const handled = options.handled ?? true;
    return {
        name: $6d877d60f0d82988$var$INTEGRATION_NAME,
        setup (client) {
            if (!('console' in (0, $bZENS.GLOBAL_OBJ))) return;
            (0, $6gxho.addConsoleInstrumentationHandler)(({ args: args, level: level })=>{
                if ((0, $dHEV3.getClient)() !== client || !levels.includes(level)) return;
                $6d877d60f0d82988$var$consoleHandler(args, level, handled);
            });
        }
    };
};
/**
 * Send Console API calls as Sentry Events.
 */ const $6d877d60f0d82988$export$caa9b6c4a4144db4 = (0, $j1zPl.defineIntegration)($6d877d60f0d82988$var$_captureConsoleIntegration);
function $6d877d60f0d82988$var$consoleHandler(args, level, handled) {
    const captureContext = {
        level: (0, $dOy0j.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, $dHEV3.withScope)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            (0, $h9p4m.addExceptionMechanism)(event, {
                handled: handled,
                type: 'auto.core.capture_console'
            });
            return event;
        });
        if (level === 'assert') {
            if (!args[0]) {
                const message = `Assertion failed: ${(0, $kWdMm.safeJoin)(args.slice(1), ' ') || 'console.assert'}`;
                scope.setExtra('arguments', args.slice(1));
                (0, $cPuNx.captureMessage)(message, captureContext);
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            (0, $cPuNx.captureException)(error, captureContext);
            return;
        }
        const message = (0, $kWdMm.safeJoin)(args, ' ');
        (0, $cPuNx.captureMessage)(message, captureContext);
    });
}


var $cPuNx = parcelRequire("cPuNx");
var $h9p4m = parcelRequire("h9p4m");
var $gfqT4 = parcelRequire("gfqT4");
var $cPuNx = parcelRequire("cPuNx");
var $w8bd7 = parcelRequire("w8bd7");
var $j1zPl = parcelRequire("j1zPl");
var $dHEV3 = parcelRequire("dHEV3");
var $bZENS = parcelRequire("bZENS");
var $f82Ej = parcelRequire("f82Ej");
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $74d4611d6428d45c$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $74d4611d6428d45c$var$checkDsn(url, dsn) || $74d4611d6428d45c$var$checkTunnel(url, tunnel);
}
function $74d4611d6428d45c$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $74d4611d6428d45c$var$removeTrailingSlash(url) === $74d4611d6428d45c$var$removeTrailingSlash(tunnel);
}
function $74d4611d6428d45c$var$checkDsn(url, dsn) {
    // Requests to Sentry's ingest endpoint must have a `sentry_key` in the query string
    // This is equivalent to the public_key which is required in the DSN
    // see https://develop.sentry.dev/sdk/overview/#parsing-the-dsn
    // Therefore, a request to the same host and with a `sentry_key` in the query string
    // can be considered a request to the ingest endpoint.
    const urlParts = (0, $f82Ej.parseStringToURLObject)(url);
    if (!urlParts || (0, $f82Ej.isURLObjectRelative)(urlParts)) return false;
    return dsn ? urlParts.host.includes(dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search) : false;
}
function $74d4611d6428d45c$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}


var $i0qqg = parcelRequire("i0qqg");

var $9X7xs = parcelRequire("9X7xs");

var $2sCie = parcelRequire("2sCie");
const $77c73c1cd6c0a74b$var$INTEGRATION_NAME = 'HttpClient';
const $77c73c1cd6c0a74b$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $77c73c1cd6c0a74b$var$INTEGRATION_NAME,
        setup (client) {
            $77c73c1cd6c0a74b$var$_wrapFetch(client, _options);
            $77c73c1cd6c0a74b$var$_wrapXHR(client, _options);
        }
    };
};
/**
 * Create events for failed client side HTTP requests.
 */ const $77c73c1cd6c0a74b$export$8a3b7aeb379b3907 = (0, $j1zPl.defineIntegration)($77c73c1cd6c0a74b$var$_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $77c73c1cd6c0a74b$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($77c73c1cd6c0a74b$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $77c73c1cd6c0a74b$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($77c73c1cd6c0a74b$var$_shouldSendDefaultPii()) {
            [requestHeaders, requestCookies] = $77c73c1cd6c0a74b$var$_parseCookieHeaders('Cookie', request);
            [responseHeaders, responseCookies] = $77c73c1cd6c0a74b$var$_parseCookieHeaders('Set-Cookie', response);
        }
        const event = $77c73c1cd6c0a74b$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error,
            type: 'fetch'
        });
        (0, $cPuNx.captureEvent)(event);
    }
}
function $77c73c1cd6c0a74b$var$_parseCookieHeaders(cookieHeader, obj) {
    const headers = $77c73c1cd6c0a74b$var$_extractFetchHeaders(obj.headers);
    let cookies;
    try {
        const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
        if (cookieString) cookies = $77c73c1cd6c0a74b$var$_parseCookieString(cookieString);
    } catch  {
    // ignore it if parsing fails
    }
    return [
        headers,
        cookies
    ];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $77c73c1cd6c0a74b$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($77c73c1cd6c0a74b$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($77c73c1cd6c0a74b$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = $77c73c1cd6c0a74b$var$_parseCookieString(cookieString);
            } catch  {
            // ignore it if parsing fails
            }
            try {
                responseHeaders = $77c73c1cd6c0a74b$var$_getXHRResponseHeaders(xhr);
            } catch  {
            // ignore it if parsing fails
            }
            requestHeaders = headers;
        }
        const event = $77c73c1cd6c0a74b$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error,
            type: 'xhr'
        });
        (0, $cPuNx.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $77c73c1cd6c0a74b$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $77c73c1cd6c0a74b$var$_parseCookieString(cookieString) {
    return cookieString.split('; ').reduce((acc, cookie)=>{
        const [key, value] = cookie.split('=');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $77c73c1cd6c0a74b$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $77c73c1cd6c0a74b$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $77c73c1cd6c0a74b$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $77c73c1cd6c0a74b$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $77c73c1cd6c0a74b$var$_wrapFetch(client, options) {
    if (!(0, $i0qqg.supportsNativeFetch)()) return;
    (0, $gfqT4.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $dHEV3.getClient)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $77c73c1cd6c0a74b$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $77c73c1cd6c0a74b$var$_wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, $bZENS.GLOBAL_OBJ))) return;
    (0, $9X7xs.addXhrInstrumentationHandler)((handlerData)=>{
        if ((0, $dHEV3.getClient)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $9X7xs.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $77c73c1cd6c0a74b$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $77c73c1cd6c0a74b$var$_shouldCaptureResponse(options, status, url) {
    return $77c73c1cd6c0a74b$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $77c73c1cd6c0a74b$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $74d4611d6428d45c$export$d92e61f5600202af)(url, (0, $dHEV3.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $77c73c1cd6c0a74b$var$_createEvent(data) {
    const client = (0, $dHEV3.getClient)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined;
    // Remove the first frame from the stack as it's the HttpClient call
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : undefined
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $77c73c1cd6c0a74b$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $h9p4m.addExceptionMechanism)(event, {
        type: `auto.http.client.${data.type}`,
        handled: false
    });
    return event;
}
function $77c73c1cd6c0a74b$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $77c73c1cd6c0a74b$var$_shouldSendDefaultPii() {
    const client = (0, $dHEV3.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}


var $jN5EV = parcelRequire("jN5EV");

var $3Kq1x = parcelRequire("3Kq1x");
var $5da41ed4d29a4a37$exports = {};
$5da41ed4d29a4a37$exports = JSON.parse("{\"name\":\"xiframe\",\"version\":\"2.0.0\",\"type\":\"module\",\"private\":true,\"description\":\"allows a customer to launch a Frame session using their SEL Cloud credentials\",\"browserslist\":\"defaults\",\"engines\":{\"node\":\">=24\",\"npm\":\">=11\"},\"targets\":{\"default\":{\"source\":[\"src/index.html\",\"src/test.html\",\"src/clear.html\"],\"context\":\"browser\",\"distDir\":\"dist\",\"outputFormat\":\"esmodule\"}},\"scripts\":{\"start\":\"parcel\",\"dev\":\"parcel serve\",\"prebuild\":\"rimraf dist\",\"build\":\"parcel build --no-cache\",\"build:pr\":\"parcel build --no-cache --no-source-maps\",\"test\":\"jest\",\"test:ci\":\"jest --ci --verbose false\",\"typecheck\":\"tsc --noEmit\",\"format\":\"prettier --write \\\"src/**/*.{js,ts,html,css,json}\\\" \\\"tests/**/*.{js,ts}\\\"\",\"format:check\":\"prettier --check \\\"src/**/*.{js,ts,html,css,json}\\\" \\\"tests/**/*.{js,ts}\\\"\",\"lint\":\"eslint src/scripts tests\",\"lint:fix\":\"eslint src/scripts tests --fix\",\"cm\":\"cz\",\"preserve\":\"npm run build\",\"serve\":\"npx http-serve -c0 dist\",\"sentry:sourcemaps\":\"sentry-cli sourcemaps inject --org enercalc-llc --project cloud-login ./dist && sentry-cli sourcemaps upload --org enercalc-llc --project cloud-login ./dist\",\"prepare\":\"husky\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/enercalc/XiFrameLauncher.git\"},\"keywords\":[],\"author\":\"ENERCALC, LLC <devops@enercalc.com>\",\"license\":\"ISC\",\"homepage\":\"https://github.com/enercalc/XiFrameLauncher\",\"devDependencies\":{\"@babel/preset-typescript\":\"^7.28.5\",\"@eslint/js\":\"^10.0.1\",\"@futureportal/parcel-transformer-package-version\":\"^1.0.0\",\"@parcel/babel-plugin-transform-runtime\":\"^2.16.0\",\"@parcel/babel-preset-env\":\"^2.16.0\",\"@sentry/cli\":\"^2.57.0\",\"axios-mock-adapter\":\"^2.1.0\",\"babel-plugin-transform-remove-console\":\"^6.9.4\",\"buffer\":\"^6.0.3\",\"crypto-browserify\":\"^3.12.1\",\"cz-conventional-changelog\":\"^3.3.0\",\"eslint\":\"^10.0.3\",\"eslint-config-prettier\":\"^10.1.8\",\"eslint-plugin-jest\":\"^29.15.0\",\"events\":\"^3.3.0\",\"hint\":\"^7.1.13\",\"husky\":\"^9.1.7\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"lint-staged\":\"^16.3.3\",\"parcel\":\"^2.16.4\",\"prettier\":\"^3.8.1\",\"process\":\"^0.11.10\",\"rimraf\":\"^6.1.3\",\"sharp\":\"^0.33.5\",\"stream-browserify\":\"^3.0.0\",\"ts-node\":\"^10.9.2\",\"typescript\":\"^5.9.3\",\"typescript-eslint\":\"^8.58.0\"},\"dependencies\":{\"@fra.me/terminal-factory\":\"^7.1.0\",\"@sentry/browser\":\"^10.22.0\",\"axios\":\"^1.13.6\",\"crypto-js\":\"^4.2.0\"},\"optionalDependencies\":{\"@parcel/watcher-linux-x64-glibc\":\"^2.5.1\"},\"lint-staged\":{\"src/**/*.{js,ts,html,css,json}\":\"prettier --write\",\"tests/**/*.{js,ts}\":\"prettier --write\"},\"config\":{\"commitizen\":{\"path\":\"./node_modules/cz-conventional-changelog\"}},\"@parcel/transformer-js\":{\"inlineEnvironment\":[\"GIT_SHA\",\"SENTRY_*\",\"CODEBUILD_RESOLVED_SOURCE_VERSION\"]}}");


var $165c87bc1a8ac848$exports = {};
$165c87bc1a8ac848$exports = JSON.parse("{\"notices\":[]}");



var $bAPCA = parcelRequire("bAPCA");

var $7dLK0 = parcelRequire("7dLK0");

var $fZ4oz = parcelRequire("fZ4oz");
/**
 * Notifications Module
 *
 * Handles display and management of notification banners and notices.
 */ 
var $bAPCA = parcelRequire("bAPCA");
function $3bb5f15271b33d7c$export$b22aa7ad5b186f13(awsNotificationBanner, severity, title, message, timestamp = new Date()) {
    if (!awsNotificationBanner) return;
    // Remove any existing severity classes
    awsNotificationBanner.classList.remove("notification-banner--critical", "notification-banner--warning", "notification-banner--info");
    // Add the appropriate severity class
    awsNotificationBanner.classList.add(`notification-banner--${severity}`);
    // Update the content
    const titleElement = awsNotificationBanner.querySelector(".notification-banner__title");
    const textElement = awsNotificationBanner.querySelector(".notification-banner__text");
    const timeElement = awsNotificationBanner.querySelector("time");
    if (titleElement) titleElement.textContent = title;
    if (textElement) textElement.textContent = message;
    if (timeElement) {
        const formattedDate = timestamp.toISOString();
        const readableDate = timestamp.toLocaleString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            timeZoneName: "short"
        });
        timeElement.setAttribute("datetime", formattedDate);
        timeElement.textContent = readableDate;
    }
    // Show the banner
    awsNotificationBanner.classList.remove("notification-banner--hidden");
}
function $3bb5f15271b33d7c$export$812b7a8239124c29(awsNotificationBanner) {
    if (!awsNotificationBanner) return;
    awsNotificationBanner.classList.add("notification-banner--hidden");
}
function $3bb5f15271b33d7c$export$574fe7292d23add(noticesData, awsNotificationBanner) {
    const hasNotices = noticesData?.notices.length > 0;
    const wasDismissed = localStorage.getItem((0, $bAPCA.StorageKeys).NOTIFICATION_DISMISSED) === "true";
    const shouldShowNotification = hasNotices && !wasDismissed;
    if (shouldShowNotification) {
        const notices = noticesData?.notices;
        notices.forEach(({ severity: severity, title: title, message: message, datetime: datetime })=>$3bb5f15271b33d7c$export$b22aa7ad5b186f13(awsNotificationBanner, severity, title, message, new Date(datetime)));
    }
}



var $cqTsR = parcelRequire("cqTsR");

var $js5ua = parcelRequire("js5ua");

var $fN5b4 = parcelRequire("fN5b4");

var $4V4G7 = parcelRequire("4V4G7");

var $ltXBQ = parcelRequire("ltXBQ");
/** @type {BrowserOptions} */ const $3e9c84597101687b$var$sentryOptions = {
    dsn: "https://c372ce87842a2c9d87d7ae05a6396094@o4509011001344000.ingest.us.sentry.io/4509555974733824",
    sendDefaultPii: true,
    integrations: [
        $417f53d2be130055$export$b4109253475213e9(),
        $6d877d60f0d82988$export$caa9b6c4a4144db4({
            levels: [
                "error"
            ]
        }),
        $77c73c1cd6c0a74b$export$8a3b7aeb379b3907({
            failedRequestStatusCodes: [
                400,
                401,
                403,
                404,
                500,
                502,
                503,
                504,
                599
            ],
            failedRequestTargets: [
                "https://enercalcapp.com/.*",
                "https://eneractivtest.com/.*"
            ]
        })
    ],
    tracesSampleRate: 0.5,
    tracePropagationTargets: [
        /^https:\/\/eneractivtest\.com/
    ],
    environment: undefined,
    release: "948b4cfe9a7086df96db806adb02ee8dc793a3da"
};
$jN5EV.init($3e9c84597101687b$var$sentryOptions);
let $3e9c84597101687b$var$terminal = null;
let $3e9c84597101687b$var$selectedLocation = "";
function $3e9c84597101687b$export$dde6bbf83f76d29d(sortedResults, availableIds) {
    const selectable = sortedResults.filter((r)=>availableIds.has(r.id));
    return selectable.length > 0 ? selectable[0] : null;
}
document.addEventListener("DOMContentLoaded", async ()=>{
    const startButton = document.getElementById("btnlaunch");
    const clearButton = document.getElementById("btnClear");
    const statusMessage = document.getElementById("loginCheck");
    const kwInput = document.getElementById("kw_number");
    const kwPasswordInput = document.getElementById("kw_password");
    const userNameInput = document.getElementById("txt_username");
    const errorContainer = document.getElementById("LoginErrorMessage");
    const selectedLocationInput = document.querySelector("#vmlocation");
    const loginForm = document.querySelector("#loginForm");
    const loginFieldset = document.querySelector("#loginFieldset");
    const browserAdvisory = document.querySelector("#browserAdvisory");
    const copyrightYear = document.querySelector("#copyrightYear");
    const awsNotificationBanner = document.getElementById("aws-notification-banner");
    const awsNotificationCloseBtn = awsNotificationBanner?.querySelector(".notification-banner__close");
    const kwnumber = (0, $7dLK0.getCookie)((0, $bAPCA.CookieNames).KWNUMBER);
    const userpass = (0, $7dLK0.getCookie)((0, $bAPCA.CookieNames).PASSWORD);
    const username = (0, $7dLK0.getCookie)((0, $bAPCA.CookieNames).USERNAME);
    /**
   * Handles errors by capturing them in Sentry and logging to the console.
   *
   * @param error - The error to handle.
   * @param message - Optional message to log with the error.
   * @returns void
   */ const handleError = (error, message = "An error occurred")=>{
        $cPuNx.captureException(error);
        console.warn(`ERROR: ${message}: ${error}`);
    };
    if (kwnumber && userpass) {
        kwInput.value = kwnumber;
        kwPasswordInput.value = userpass;
        userNameInput.value = username ?? "";
        (0, $js5ua.setSentryUser)(kwInput, userNameInput);
    }
    // Prevent spaces from being used in the username field
    userNameInput.addEventListener("input", function() {
        this.value = this.value.replace(/\s+/g, "");
    });
    // Build dependencies object for session functions
    const sessionDeps = {
        startButton: startButton,
        statusMessage: statusMessage,
        loginFieldset: loginFieldset,
        kwInput: kwInput,
        kwPasswordInput: kwPasswordInput,
        userNameInput: userNameInput,
        terminal: null,
        serviceUrl: (0, $bAPCA.ApiEndpoints).FRAME_GQL
    };
    const setTerminal = (newTerminal)=>{
        $3e9c84597101687b$var$terminal = newTerminal;
        sessionDeps.terminal = newTerminal;
    };
    selectedLocationInput.addEventListener("change", async (event)=>{
        const target = event.target;
        $3e9c84597101687b$var$selectedLocation = target.value;
        (0, $js5ua.setSentryLocation)(target.options[target.selectedIndex]);
        try {
            const account = (0, $ltXBQ.getEnumKeyByEnumValue)((0, $bAPCA.AwsRegionNames), target.value);
            const token = await (0, $fN5b4.getToken)();
            await (0, $cqTsR.loadFrame)((0, $bAPCA.FrameAccountConfigs)[account], token, sessionDeps, setTerminal);
        } catch (error) {
            handleError(error, "Error changing location");
        }
    });
    // Validate form
    loginForm.addEventListener("submit", async (event)=>{
        event.preventDefault();
        // check form validity
        if (!loginForm.checkValidity()) {
            console.warn("User did not fill out all required fields");
            loginForm.reportValidity();
            return;
        }
        await validateCredentials();
        return;
    });
    // Clear browser cookies and local storage
    clearButton.addEventListener("click", async ()=>{
        try {
            (0, $7dLK0.clearCookie)((0, $bAPCA.CookieNames).KWNUMBER);
            (0, $7dLK0.clearCookie)((0, $bAPCA.CookieNames).PASSWORD);
            (0, $7dLK0.clearCookie)((0, $bAPCA.CookieNames).USERNAME);
            (0, $ltXBQ.clearLocalStorage)();
            statusMessage.innerText = "Login information cleared";
            loginForm.reset();
        } catch (error) {
            handleError(error, "Error clearing cookies");
            errorContainer.innerText = "Error clearing login. Please reload the page and try again.";
        }
    });
    /**
   * Validates the user's credentials and starts or resumes a Frame session.
   *
   * @returns A promise that resolves when the user's credentials are validated.
   * @throws {Error} If we cannot validate the users credentials.
   */ const validateCredentials = async ()=>{
        if ($3e9c84597101687b$var$terminal) {
            const session = await $3e9c84597101687b$var$terminal.getOpenSession();
            const sessionState = session?.state;
            if (session && sessionState === (0, $4DjaP.SessionState).OPEN) {
                await $3e9c84597101687b$var$terminal.resume(session.id);
                (0, $4V4G7.toggleStartButton)(startButton, true, "Resuming...");
            } else if (session && sessionState === (0, $4DjaP.SessionState).CLOSING) {
                // Wait for session to close before starting a new one
                (0, $4V4G7.toggleStartButton)(startButton, false, "Waiting for session to close...");
                statusMessage.innerText = "Previous session is closing. Please wait...";
                const sessionClosed = await (0, $cqTsR.checkUntilClosed)(sessionDeps);
                if (sessionClosed) // Recursively call validateCredentials after session is closed
                await validateCredentials();
            } else try {
                const response = await (0, $3Kq1x.default).post((0, $bAPCA.ApiEndpoints).LOGIN, `pLogin=${kwInput.value}&pPwd=${kwPasswordInput.value}`);
                const ologin = response.data.APIResult;
                if (ologin === 1) {
                    errorContainer.textContent = "";
                    (0, $7dLK0.setCookie)((0, $bAPCA.CookieNames).KWNUMBER, kwInput.value, 180);
                    (0, $7dLK0.setCookie)((0, $bAPCA.CookieNames).PASSWORD, kwPasswordInput.value, 180);
                    (0, $7dLK0.setCookie)((0, $bAPCA.CookieNames).USERNAME, userNameInput.value, 180);
                    (0, $js5ua.setSentryUser)(kwInput, userNameInput);
                    statusMessage.innerText = "Connection in progress";
                    const account = (0, $ltXBQ.getEnumKeyByEnumValue)((0, $bAPCA.AwsRegionNames), $3e9c84597101687b$var$selectedLocation);
                    if (account && (0, $bAPCA.FrameAccountConfigs)[account]) await (0, $cqTsR.startSession)((0, $bAPCA.FrameAccountConfigs)[account].applicationId, sessionDeps);
                    else {
                        console.warn("Unknown region selected in validateCredentials:", $3e9c84597101687b$var$selectedLocation);
                        errorContainer.innerText = "Unknown location selected. Please refresh and try again.";
                    }
                    await (0, $js5ua.postScreenSpecs)(kwInput);
                } else errorContainer.innerText = "Your KW number and/or password were not valid, were missing, or your company / agency required that we disable cloud access.";
            } catch (error) {
                handleError(error, "Error validating credentials");
            }
        }
    };
    /**
   * Gets the region information from latency results for a given region ID.
   *
   * @param results - The latency results array.
   * @param region - The AWS region ID to find.
   * @returns The region information or undefined if not found.
   */ const getRegionInfoFromResults = (results, region)=>{
        return results.find((r)=>r.id === region);
    };
    /**
   * Find the lowest latency region and select it for the user.
   *
   * @param token - Frame token.
   * @returns void
   */ const startApp = async (token)=>{
        const latencyResults = [];
        // ping each region and push the results to latencyResults array
        Object.entries((0, $bAPCA.AwsRegionNames)).forEach(([, value])=>{
            const promise = (0, $fZ4oz.default)(value);
            if (promise) latencyResults.push(promise);
        });
        const results = await Promise.all(latencyResults);
        // sort the results by latency
        results.sort((a, b)=>a.latency - b.latency);
        // Build the set of region IDs that are actually present in the <select>.
        // This is the canonical authoritative set — regions in AwsRegionNames but absent
        // from the <select> (NORCAL, SYDNEY) must not be auto-selected.
        const availableOptionValues = new Set(Array.from(selectedLocationInput.options).filter((opt)=>opt.value !== "" && !opt.disabled).map((opt)=>opt.value));
        const regionWithLowestLatency = $3e9c84597101687b$export$dde6bbf83f76d29d(results, availableOptionValues);
        if (!regionWithLowestLatency) {
            console.warn("startApp: no selectable regions available in <select>; skipping auto-selection");
            (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
            return;
        }
        const options = Array.from(selectedLocationInput.options);
        // update the labels with the latency
        options.forEach((option)=>{
            const regionInfo = getRegionInfoFromResults(results, option.value);
            if (regionInfo === undefined) return;
            if (regionWithLowestLatency.id === regionInfo.id) option.selected = true;
            option.label = `${option.dataset.name} (${regionInfo.latency} ms)`;
        });
        // start with the region with the lowest latency selected
        $3e9c84597101687b$var$selectedLocation = regionWithLowestLatency.id;
        (0, $js5ua.setSentryLocation)(options.find((option)=>option.value === $3e9c84597101687b$var$selectedLocation));
        const account = (0, $ltXBQ.getEnumKeyByEnumValue)((0, $bAPCA.AwsRegionNames), $3e9c84597101687b$var$selectedLocation);
        await (0, $cqTsR.loadFrame)((0, $bAPCA.FrameAccountConfigs)[account], token, sessionDeps, setTerminal);
        return;
    };
    /**
   * Detects the user's browser and provides browser-specific advisories.
   *
   * @returns True if the browser is supported, false otherwise.
   */ const browserDetection = ()=>{
        if ((0, $4DjaP.isBrowserSupported)()) return true;
        browserAdvisory.classList.remove("hidden");
        (0, $4V4G7.toggleStartButton)(startButton, false, "Launch");
        return false;
    };
    // Add event listener to close button
    if (awsNotificationCloseBtn) awsNotificationCloseBtn.addEventListener("click", ()=>{
        (0, $3bb5f15271b33d7c$export$812b7a8239124c29)(awsNotificationBanner);
        // Store in localStorage that the user has dismissed this notification
        localStorage.setItem((0, $bAPCA.StorageKeys).NOTIFICATION_DISMISSED, "true");
    });
    (0, $3bb5f15271b33d7c$export$574fe7292d23add)((0, (/*@__PURE__*/$parcel$interopDefault($165c87bc1a8ac848$exports))), awsNotificationBanner);
    (0, $4V4G7.updateYear)(copyrightYear);
    browserDetection();
    let frameToken = null;
    try {
        frameToken = await (0, $fN5b4.getToken)();
    } catch (error) {
        handleError(error, "Error getting token");
    }
    if (!frameToken) {
        errorContainer.textContent = "We're having trouble connecting to the cloud platform. Please reload the page and try again. If the problem persists, please contact support.";
        return;
    }
    try {
        await startApp(frameToken);
    } catch (error) {
        handleError(error, "Error starting app");
        errorContainer.textContent = "We're having trouble starting a cloud session. Please reload the page and try again. If the problem persists, please contact support.";
    }
});


//# sourceMappingURL=src1970441075.d234cbe6.js.map
